// ============================================
// HORIZONTAL MOON MAP - Form Handler & Backend Sync
// Handles Add to Cart, data collection for both moons
// H-Moon variant with two moons side by side
// ============================================

(function() {
    'use strict';

    // ============================================
    // DOM HELPERS (the file used to lean on jQuery; these keep its semantics)
    // ============================================
    function q(sel, root) { return (root || document).querySelector(sel); }
    function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
    // Value of the first match ('' for none, like jQuery's .val() || '').
    function val(sel) { var el = q(sel); return el ? el.value : undefined; }
    function setVal(sel, v) { qa(sel).forEach(function (el) { el.value = v; }); }
    function setText(sel, t) { qa(sel).forEach(function (el) { el.textContent = t; }); }
    function attr(el, name) { return el ? el.getAttribute(name) : undefined; }
    // A real DOM event: reaches every addEventListener listener.
    function fire(el, type) {
        if (el) el.dispatchEvent(new Event(type, { bubbles: true }));
        return el;
    }
    // jQuery 3's ready fires asynchronously, one task after DOMContentLoaded
    // (after every native DOMContentLoaded listener); keep that ordering.
    function onReady(fn) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function () { setTimeout(fn, 0); });
        } else {
            setTimeout(fn, 0);
        }
    }
    // Delegated listener with jQuery's semantics: fn runs with `this` = each
    // matching element from the target up to the document, until propagation
    // is stopped; returning false = preventDefault + stopPropagation.
    function delegate(types, selector, fn) {
        types.split(' ').forEach(function (type) {
            document.addEventListener(type, function (e) {
                var el = e.target;
                while (el && el !== document) {
                    if (el.nodeType === 1 && el.matches(selector)) {
                        if (fn.call(el, e) === false) { e.preventDefault(); e.stopPropagation(); }
                        if (e.cancelBubble) break;
                    }
                    el = el.parentNode;
                }
            });
        });
    }
    // jQuery fadeIn / fadeOut end states: display block / none, no inline
    // opacity left behind.
    function fadeIn(sel, ms) {
        qa(sel).forEach(function (el) {
            if (getComputedStyle(el).display !== 'none' && el.style.display !== 'none') return;
            el.style.display = 'block';
            if (el.animate) el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: ms || 400 });
        });
    }
    function fadeOut(sel, ms, done) {
        var els = typeof sel === 'string' ? qa(sel) : [sel];
        els.forEach(function (el) {
            if (!el) return;
            var finish = function () { el.style.display = 'none'; if (done) done.call(el); };
            if (getComputedStyle(el).display === 'none') { if (done) done.call(el); return; }
            if (el.animate) {
                var a = el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: ms || 400 });
                a.onfinish = finish;
            } else {
                finish();
            }
        });
    }
    // $.ajax with a data object: jQuery.param form encoding (nested objects
    // as key[sub]=v, jQuery 3 does not turn %20 into +) and jQuery's headers,
    // so Shopify's cart API receives exactly what it always did.
    function formEncode(obj) {
        var parts = [];
        function add(key, value) {
            if (typeof value === 'function') value = value();
            parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(value == null ? '' : value));
        }
        function build(prefix, value) {
            if (Array.isArray(value)) {
                value.forEach(function (v, i) {
                    build(prefix + '[' + (typeof v === 'object' && v != null ? i : '') + ']', v);
                });
            } else if (value !== null && typeof value === 'object') {
                Object.keys(value).forEach(function (k) { build(prefix + '[' + k + ']', value[k]); });
            } else {
                add(prefix, value);
            }
        }
        Object.keys(obj).forEach(function (k) { build(k, obj[k]); });
        return parts.join('&');
    }
    // XMLHttpRequest, not fetch, as jQuery used: Shopify's shop-events
    // listener (add-to-cart analytics) reads cart requests, and its fetch
    // path expects a JSON body; a form-encoded fetch fails its parse.
    function postForm(url, data) {
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', url, true);
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
            xhr.setRequestHeader('Accept', 'application/json, text/javascript, */*; q=0.01');
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            xhr.onload = function () {
                if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 304) {
                    try { resolve(JSON.parse(xhr.responseText)); } catch (e) { reject(new Error('parsererror')); }
                } else {
                    reject(new Error(xhr.statusText || ('HTTP ' + xhr.status)));
                }
            };
            xhr.onerror = function () { reject(new Error('error')); };
            xhr.send(formEncode(data));
        });
    }

    // ============================================
    // CONFIGURATION
    // ============================================
    var CONFIG = {
        productType: 'H-Moon-Skylit',
        apiEndpoint: 'https://admin.skylitstudio.co.uk',
        adminEndpoint: 'https://admin.skylitstudio.co.uk',
        cookieName: 'h_moon_map_data',
        cookieExpiry: 7
    };

    // Gift product variant IDs — kept in sync with starmap-v2/locationmap/
    // moon-myjs GIFT_IDS so cart-attrs-sync's variant detection covers
    // hor-moon-added gift lines too.
    var GIFT_IDS = {
        ribbon:   '55259137802617',
        giftwrap: '56160831930745',
        bundle:   '56160845988217'
    };

    // gift_option key used by the admin row + cart line.
    function readGiftOptionFromUI() {
        var s = window.hMoonState && window.HMoonCore ? window.HMoonCore.store() : null;
        return (s && s.gift && s.gift.selectedOption) || 'none';
    }

    // Order ID for backend tracking
    var order_id = Math.random().toString(36).slice(2);
    var hmCartThumbnailToken = '';

    // Festive gift-wrap paper picker and ribbon colour (family moon). Their
    // visibility follows the gift choice through Alpine bindings in the
    // section; this wires the pickers themselves.
    window.hmGiftPaper = (window.SkylitGifts && window.SkylitGifts.recallPaperFor('hm_' + order_id)) || 'dots';
    // Ribbon colour on the ribbon / bundle add-on, remembered like the paper.
    window.hmRibbonColor = (window.SkylitGifts && window.SkylitGifts.recallRibbonFor('hm_' + order_id)) || 'Red';
    onReady(function () {
        var picker = window.SkylitGifts && window.SkylitGifts.bindPaperPicker(document.getElementById('hm-gift-paper'), function (id) {
            window.hmGiftPaper = id;
            if (window.SkylitGifts) window.SkylitGifts.rememberPaper('hm_' + order_id, id);
            if (typeof window.renderHOverlays === 'function') window.renderHOverlays();
            // Repaint an already-open 3D parcel so a swatch click matches the 2D preview.
            if (window.HMoonFramedMockup && typeof window.HMoonFramedMockup.setWrapDesign === 'function') {
                window.HMoonFramedMockup.setWrapDesign(id);
            }
        });
        window.hmGiftPaperPicker = picker;
        if (picker) picker.set(window.hmGiftPaper);
        var rpicker = window.SkylitGifts && window.SkylitGifts.bindRibbonPicker(document.getElementById('hm-gift-ribbon'), function (name) {
            window.hmRibbonColor = name;
            if (window.SkylitGifts) window.SkylitGifts.rememberRibbon('hm_' + order_id, name);
            if (typeof window.renderHOverlays === 'function') window.renderHOverlays();
        });
        window.hmRibbonPicker = rpicker;
        if (rpicker) rpicker.set(window.hmRibbonColor);
    });

    // Cart tracking for existing orders
    var cart_order_id_present = [];
    var cart_order_id_present_id = [];
    var isEditMode = false;
    function setEditMode(on) {
        isEditMode = !!on;
        var s = window.hMoonState && (hMoonStateProxy || window.hMoonState);
        if (s) s.editMode = isEditMode;
    }
    // Edit mode: the Framed selection came from the cart's frame add-on line
    // (not the unified Framed variant) — confirm must keep the two-line
    // structure. Set by the pairedFrame hydration in the edit boot path.
    var hmFrameFromAddon = false;
    var hmAddonFrameColour = null;
    var hmFrameFlipDone = false;

    // ── The customizer's state: Alpine.store('hmoon') ───────────────────
    // One store for the whole customizer, like the single moon's. The
    // sidebar binds to it (hor-moon-ui.js); write it through the HMoonCore
    // actions below, or the window.* accessors kept for the generator.
    window.hMoonState = {
      orderId: order_id,
      editMode: false,
      // Sidebar step (0-3).
      step: 0,
      // Per-moon Moment progress: a location entered, a date picked.
      // window.hUserEnteredLocations / hUserSelectedDates are accessors.
      locations: { moon1: false, moon2: false, moon3: false, moon4: false },
      dates: { moon1: false, moon2: false, moon3: false, moon4: false },
      // Design step. window.hMoonTemplateCount / hMoonBackground /
      // hMoonTextures are accessors onto these (below).
      template: 2,
      composition: 'classic',
      background: 'family3',
      textures: { 1: 'silver', 2: 'silver', 3: 'silver', 4: 'silver' },
      // Fonts. Scope "both" applies a pick to the title/subtitle (message)
      // and the per-moon labels (details) alike.
      fontScope: 'both',
      messageFont: 'Josefin Sans',
      detailsFont: 'Josefin Sans',
      // Finish step. `sel` keeps a size / frame per product type, so going
      // Framed -> Print -> Framed brings back the Framed choices.
      type: '',
      sel: {},
      variantId: null,
      // Wave 24 — mirrors moon's Wave 21/22. hor-moon has equivalent
      // state globals (hRibbonSelected etc.) that we proxy through to
      // the store so Alpine bindings can react to gift/validation/price
      // changes without manual sync.
      gift: {
        ribbon: false,
        giftWrap: false,
        bundle: false,
        selectedOption: 'none',
      },
      price: {
        variantPence: null,
      },
    };
    var hMoonStateProxy = null;
    document.addEventListener('alpine:init', function () {
      if (window.Alpine) {
        window.Alpine.store('hmoon', window.hMoonState);
        hMoonStateProxy = window.Alpine.store('hmoon');
      }
    });
    window.hMoonStoreSet = function (key, value) {
      if (hMoonStateProxy) { hMoonStateProxy[key] = value; return; }
      if (window.Alpine && window.Alpine.store) {
        var s = window.Alpine.store('hmoon');
        if (s) { s[key] = value; return; }
      }
      window.hMoonState[key] = value;
    };

    // Wave 24 — gift state proxies (matching moon's Wave 22 pattern).
    // hRibbonSelected / hGiftWrapSelected / hBundleSelected /
    // hSelectedGiftOption become accessor properties routing through
    // Alpine.store('hmoon').gift. Existing read/write sites unchanged.
    function _hStoreOrInit() { return hMoonStateProxy || window.hMoonState; }
    var hStore = _hStoreOrInit;
    ['ribbon', 'giftWrap', 'bundle'].forEach(function (k) {
      var winKey = 'h' + k.charAt(0).toUpperCase() + k.slice(1) + 'Selected';
      // Result keys: hRibbonSelected, hGiftWrapSelected, hBundleSelected
      Object.defineProperty(window, winKey, {
        get: function () {
          var s = _hStoreOrInit();
          return !!(s && s.gift && s.gift[k]);
        },
        set: function (v) {
          var s = _hStoreOrInit();
          if (s && s.gift) s.gift[k] = !!v;
        },
        configurable: true,
        enumerable: true,
      });
    });
    // The generator and the reorder swap read and write these globals; they
    // route through the store so the tiles follow.
    var hmBootTextures = window.hMoonTextures;
    if (hmBootTextures) Object.keys(hmBootTextures).forEach(function (k) { window.hMoonState.textures[k] = hmBootTextures[k]; });
    Object.defineProperty(window, 'hMoonTextures', {
      get: function () { return _hStoreOrInit().textures; },
      set: function (v) { _hStoreOrInit().textures = Object.assign({}, v); },
      configurable: true,
      enumerable: true,
    });
    Object.defineProperty(window, 'hMoonTemplateCount', {
      get: function () { return _hStoreOrInit().template; },
      set: function (v) { _hStoreOrInit().template = parseInt(v, 10) || 2; },
      configurable: true,
      enumerable: true,
    });
    Object.defineProperty(window, 'hMoonBackground', {
      get: function () { return _hStoreOrInit().background; },
      set: function (v) { _hStoreOrInit().background = v || 'family3'; },
      configurable: true,
      enumerable: true,
    });
    [['hMoonFontScope', 'fontScope', 'both'], ['hMoonMessageFont', 'messageFont', 'Josefin Sans'],
     ['hMoonDetailsFont', 'detailsFont', 'Josefin Sans'], ['hMoonFont', 'messageFont', 'Josefin Sans']].forEach(function (m) {
      Object.defineProperty(window, m[0], {
        get: function () { return _hStoreOrInit()[m[1]]; },
        set: function (v) { _hStoreOrInit()[m[1]] = v || m[2]; },
        configurable: true,
        enumerable: true,
      });
    });
    Object.defineProperty(window, 'hUserEnteredLocations', {
      get: function () { return _hStoreOrInit().locations; },
      set: function (v) { _hStoreOrInit().locations = Object.assign({}, v); },
      configurable: true,
      enumerable: true,
    });
    Object.defineProperty(window, 'hUserSelectedDates', {
      get: function () { return _hStoreOrInit().dates; },
      set: function (v) { _hStoreOrInit().dates = Object.assign({}, v); },
      configurable: true,
      enumerable: true,
    });
    Object.defineProperty(window, 'hSelectedGiftOption', {
      get: function () {
        var s = _hStoreOrInit();
        return (s && s.gift) ? s.gift.selectedOption : 'none';
      },
      set: function (v) {
        var s = _hStoreOrInit();
        if (s && s.gift) s.gift.selectedOption = v || 'none';
      },
      configurable: true,
      enumerable: true,
    });

    // ── Finish step: product type / size / frame colour / gift ──────────
    // The store is the only source of truth. The tiles bind to it
    // (hor-moon-ui.js), and every writer comes through these actions: tile
    // clicks, the ?variant= deep link, the saved-design hydrator, the
    // edit-mode frame flip and the Print gift downgrade.
    // window.hProductVariants / hVariantMap / hVariantMoney are printed by
    // the section.
    function hVariants() { return window.hProductVariants || []; }
    function hNorm(v) {
        if (v === undefined || v === null) return null;
        var t = String(v).trim();
        return t === '' ? null : t;
    }
    // Liquid's handleize, which the section uses for data-state.
    function hHandleize(s) {
        return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }
    function hStateKey(type) { return type ? hHandleize(type) + '__picker' : ''; }
    function hProductTypes() {
        var out = [];
        hVariants().forEach(function (v) { if (out.indexOf(v.option1) === -1) out.push(v.option1); });
        return out;
    }
    function hSizesFor(type) {
        var out = [];
        hVariants().forEach(function (v) { if (v.option1 === type && out.indexOf(v.option2) === -1) out.push(v.option2); });
        return out;
    }
    function hFramesFor(type) {
        var out = [];
        hVariants().forEach(function (v) {
            if (v.option1 === type && hNorm(v.option3) && out.indexOf(v.option3) === -1) out.push(v.option3);
        });
        return out;
    }
    // Print and Canvas carry option3 "No Frame", which is not a choice.
    function hIsFramelessType(type) {
        var t = String(type || '').toLowerCase();
        return t.indexOf('print') !== -1 || t.indexOf('canvas') !== -1 ||
            t.indexOf('digital') !== -1 || t.indexOf('unframed') !== -1;
    }
    function hHasFrameChoice(type) { return !!type && !hIsFramelessType(type) && hFramesFor(type).length > 0; }
    function hIsPrintType(type) {
        var t = String(type === undefined ? hStore().type : type || '').toLowerCase();
        return t.indexOf('print') !== -1 || t.indexOf('unframed') !== -1 || t.indexOf('tablou') !== -1;
    }

    // With a frame chosen a size is that exact variant, otherwise any
    // variant of the type + size.
    function hSizeVariant(type, size, frame) {
        if (frame) {
            var v = (window.hVariantMap || {})[type + '|' + size + '|' + frame];
            return (v && v.available) ? v : null;
        }
        return hVariants().find(function (v) {
            return v.option1 === type && v.option2 === size && v.available;
        }) || null;
    }
    // Large framed parcels and the big canvas ship UK-only (delivery profile
    // "Large framed — UK only"). The section sets SKYLIT_HMOON_NON_UK from
    // the shopper's market.
    function hIsUkOnlySize(type, size) {
        if (!window.SKYLIT_HMOON_NON_UK) return false;
        type = String(type || ''); size = String(size || '');
        if (type.indexOf('Frame') !== -1 && (size.indexOf('70') !== -1 || size.indexOf('80') !== -1)) return true;
        return type.indexOf('Canvas') !== -1 && size.indexOf('70') !== -1;
    }
    function hSizeAvailable(type, size) {
        if (hIsUkOnlySize(type, size)) return false;
        var frame = hHasFrameChoice(type) ? (hStore().sel[type] || {}).frame : null;
        return !!hSizeVariant(type, size, frame);
    }
    function hFindVariant(o1, o2, o3) {
        o1 = hNorm(o1); o2 = hNorm(o2); o3 = hNorm(o3);
        var exact = hVariants().find(function (v) {
            return hNorm(v.option1) === o1 && hNorm(v.option2) === o2 && hNorm(v.option3) === o3;
        });
        if (exact) return exact;
        var partial = hVariants().filter(function (v) { return hNorm(v.option1) === o1 && hNorm(v.option2) === o2; });
        if (partial.length) return partial.find(function (v) { return v.available; }) || partial[0];
        return null;
    }
    function hCurrentSelection() {
        var s = hStore();
        var type = s.type || null;
        var sel = (type && s.sel[type]) || {};
        return {
            type: type,
            size: sel.size || null,
            frame: hHasFrameChoice(type) ? (sel.frame || null) : null
        };
    }
    function hCurrentVariant() {
        var c = hCurrentSelection();
        if (!c.type) return null;
        return hFindVariant(c.type, c.size, c.frame) || hVariants()[0] || null;
    }

    function hSetSel(type, patch) {
        var s = hStore();
        var next = {};
        Object.keys(s.sel).forEach(function (k) { next[k] = Object.assign({}, s.sel[k]); });
        next[type] = Object.assign({}, next[type] || {}, patch);
        s.sel = next;
    }
    // A type seen for the first time starts on its first buyable size
    // (A4) and first frame colour, as the tiles always did.
    function hDefaultSize(type) {
        var sizes = hSizesFor(type);
        return sizes.find(function (sz) { return hSizeAvailable(type, sz); }) || sizes[0] || null;
    }
    // A size the current frame isn't made in moves to the NEAREST size that
    // is (the smaller one on a tie): 70 x 50 in Dark Brown becomes 50 x 40.
    function hEnsureSizeAvailable(type) {
        var sel = hStore().sel[type] || {};
        if (!sel.size || hSizeAvailable(type, sel.size)) return;
        var sizes = hSizesFor(type);
        var from = sizes.indexOf(sel.size);
        if (from === -1) from = 0;
        var best = null, bestD = Infinity;
        sizes.forEach(function (sz, i) {
            var d = Math.abs(i - from);
            if (d < bestD && hSizeAvailable(type, sz)) { best = sz; bestD = d; }
        });
        if (best) hSetSel(type, { size: best });
    }

    function hSelectType(type, opts) {
        if (!type || hProductTypes().indexOf(type) === -1) return false;
        hStore().type = type;
        var sel = hStore().sel[type] || {};
        var patch = {};
        if (hHasFrameChoice(type) && !sel.frame) patch.frame = hFramesFor(type)[0] || null;
        if (Object.keys(patch).length) hSetSel(type, patch);
        if (!sel.size) hSetSel(type, { size: hDefaultSize(type) });
        hEnsureSizeAvailable(type);
        hApplySelection(opts);
        return true;
    }
    function hSelectSize(size, opts) {
        opts = opts || {};
        var type = hStore().type;
        if (!type || !size) return false;
        if (!opts.force && !hSizeAvailable(type, size)) return false;
        hSetSel(type, { size: size });
        hApplySelection(opts);
        return true;
    }
    function hSelectFrame(frame, opts) {
        var type = hStore().type;
        if (!type || !frame || !hHasFrameChoice(type)) return false;
        hSetSel(type, { frame: frame });
        hEnsureSizeAvailable(type);
        hApplySelection(opts);
        return true;
    }
    // Switch product type but keep the size the customer is on (and
    // optionally set the frame colour): the edit-mode frame flip between the
    // Print + frame add-on pair and the unified Framed variant.
    function hSelectTypeKeepSize(type, frame) {
        var cur = hCurrentSelection();
        var patch = {};
        if (cur.size && hSizesFor(type).indexOf(cur.size) !== -1) patch.size = cur.size;
        if (frame && hHasFrameChoice(type)) patch.frame = frame;
        if (Object.keys(patch).length) hSetSel(type, patch);
        return hSelectType(type);
    }
    // A saved design's type / size / frame, matched loosely: sizes vary in
    // punctuation and axis order across saves ("50 x 40 cm" vs "40x50cm").
    function hRestoreSelection(savedType, savedSize, savedFrame) {
        var lc = function (t) { return (t || '').replace(/ - Sold Out/i, '').trim().toLowerCase(); };
        var sz = function (t) { return (t || '').toLowerCase().replace(/cm/g, '').replace(/\s+/g, ''); };
        var type = savedType ? hProductTypes().find(function (t) { return lc(t) === lc(savedType); }) : null;
        type = type || hStore().type;
        if (!type) return;
        var patch = {};
        if (savedSize) {
            var b = sz(savedSize);
            var size = hSizesFor(type).find(function (t) {
                var a = sz(t);
                return a && (a === b || a === b.split('x').reverse().join('x'));
            });
            if (size) patch.size = size;
        }
        if (savedFrame && hHasFrameChoice(type)) {
            var frame = hFramesFor(type).find(function (f) { return lc(f) === lc(savedFrame); });
            if (frame) patch.frame = frame;
        }
        if (Object.keys(patch).length) hSetSel(type, patch);
        hSelectType(type);
    }

    // Wrapping add-on prices (major units, GBP), the smallest-tier fallback
    // when SkylitGifts (priced by the size being wrapped) is missing.
    // Display-only: the add-on still posts as its own paired cart line.
    var H_GIFT_ADDON = { none: 0, ribbon: 2.49, giftwrap: 3.69, bundle: 4.99 };
    function hGiftAddon() {
        var opt = hStore().gift.selectedOption || 'none';
        if (opt !== 'none') {
            try {
                var pence = window.SkylitGifts && window.SkylitGifts.priceFor(opt, hCurrentSelection().size || '');
                if (pence) return pence / 100;
            } catch (e) {}
        }
        return H_GIFT_ADDON[opt] || 0;
    }
    // Footer total = variant price + wrapping, in the variant's own money
    // format (hVariantMoney is Liquid's `money` output per variant).
    function hStampPrice() {
        var v = hCurrentVariant();
        if (!v) return;
        var money = (window.hVariantMoney || {})[v.id] || '';
        var m = money.match(/^(\D*)([\d,]+(?:\.\d+)?)/);
        var text = m ? m[1] + (parseFloat(m[2].replace(/,/g, '')) + hGiftAddon()).toFixed(2) : money;
        setText('.h-add__cart--price p', text);
    }

    // Push the resolved variant everywhere it is read: #h-var_id (the cart
    // add, pair-offer-note), the hidden product select, the preview frame
    // colour and the footer total.
    function hApplySelection() {
        var v = hCurrentVariant();
        if (!v) return;
        var s = hStore();
        s.variantId = v.id;
        s.price.variantPence = v.price;
        var select = q('#h-product-select');
        if (select) select.value = String(v.id);
        setVal('#h-var_id', String(v.id));
        var c = hCurrentSelection();
        if (typeof window.hApplyFrameStyle === 'function') window.hApplyFrameStyle(c.frame);
        document.body.classList.toggle('hmoon-canvas-selected', String(c.type || '').toLowerCase().indexOf('canvas') !== -1);
        try { if (window.SkylitGifts) window.SkylitGifts.refreshLabels(c.size || ''); } catch (e) {}
        // Print can't be gift-wrapped: Gift Wrap and Bundle drop to no gift.
        var g = s.gift.selectedOption;
        if (hIsPrintType(c.type) && (g === 'giftwrap' || g === 'bundle')) hSetGift('none', { degrade: true });
        hStampPrice();
        if (typeof window.onHMoonVariantChange === 'function') window.onHMoonVariantChange(v);
    }

    function hSetGift(option, opts) {
        opts = opts || {};
        option = option || 'none';
        var s = hStore();
        s.gift.ribbon = option === 'ribbon' || option === 'bundle';
        s.gift.giftWrap = option === 'giftwrap' || option === 'bundle';
        s.gift.bundle = option === 'bundle';
        s.gift.selectedOption = option;
        // Changing the wrapping resets the "peek" (hide the wrap preview),
        // except when Print quietly downgrades it.
        if (!opts.degrade) window.hmoonGiftPeekHidden = false;
        if (typeof window.onHMoonGiftChange === 'function') window.onHMoonGiftChange(option, opts);
        hStampPrice();
    }

    // ── Design step: template / composition / background / moon hue ─────
    // The generator draws (updateTemplateLayout, applyBackground,
    // setHMoonTextureVariant); these own the choice. opts.flip: false skips
    // the FLIP glide (hydration), opts.silent skips the draft autosave.
    function hmFlip(mutate, opts) {
        if (opts.flip !== false && typeof window.hMoonFlip === 'function') window.hMoonFlip(mutate);
        else mutate();
    }
    function hSetTemplate(n, opts) {
        opts = opts || {};
        n = parseInt(n, 10);
        if (!(n >= 2 && n <= 4)) return;
        var s = hStore();
        hmFlip(function () {
            // Portrait 2x2 only exists with 4 moons: leaving 4 goes back
            // to Classic.
            if (n !== 4 && s.composition === 'quad-portrait') hSetComposition('classic', { flip: false, silent: true });
            if (typeof window.updateHMoonTemplateLayout === 'function') window.updateHMoonTemplateLayout(n);
            s.template = n;
        }, opts);
        document.dispatchEvent(new CustomEvent('hmoon:template', { detail: { count: n } }));
        if (!opts.silent) scheduleHmAutosave();
    }
    function hSetComposition(comp, opts) {
        opts = opts || {};
        comp = comp || 'classic';
        var s = hStore();
        s.composition = comp;
        hmFlip(function () {
            qa('.h-custom-frame').forEach(function (f) { f.setAttribute('data-composition', comp); });
            if (comp === 'quad-portrait' && s.template !== 4) hSetTemplate(4, { flip: false, silent: true });
            if (typeof window.hMoonUpdateItemSizes === 'function') window.hMoonUpdateItemSizes();
            if (typeof window.updateHMoonPrintAspect === 'function') window.updateHMoonPrintAspect();
        }, opts);
        // The ribbon image swaps between landscape and portrait.
        if (typeof window.renderHOverlays === 'function') window.renderHOverlays();
        if (!opts.silent) scheduleHmAutosave();
    }
    function hSetBackground(key, opts) {
        opts = opts || {};
        if (!key) return;
        hStore().background = key;
        if (typeof window.hApplyBackground === 'function') window.hApplyBackground(key);
        if (!opts.silent) scheduleHmAutosave();
    }
    function hSetTexture(moonId, variant, opts) {
        opts = opts || {};
        moonId = parseInt(moonId, 10);
        if (!moonId) return;
        variant = variant || 'silver';
        hStore().textures[moonId] = variant;
        if (typeof window.setHMoonTextureVariant === 'function') window.setHMoonTextureVariant(variant, moonId);
        if (!opts.silent) scheduleHmAutosave();
    }

    // A font pick applies to the current scope's text.
    function hSetFontScope(scope) {
        if (scope === 'message' || scope === 'details' || scope === 'both') hStore().fontScope = scope;
    }
    function hChooseFont(font, opts) {
        opts = opts || {};
        if (!font) return;
        if (typeof window.hApplyFont === 'function') window.hApplyFont(font, hStore().fontScope);
        if (!opts.silent) scheduleHmAutosave();
    }
    // A saved design's two fonts (older saves carry one font for both).
    function hSetFonts(message, details) {
        if (typeof window.hApplyFont !== 'function') return;
        if (message) window.hApplyFont(message, 'message');
        if (details || message) window.hApplyFont(details || message, 'details');
    }

    // Add to cart needs a location and a date for every moon on the print.
    function hButtonLabel() {
        var s = hStore();
        var needLoc = false, needDate = false;
        for (var i = 1; i <= (s.template || 2); i++) {
            if (!s.locations['moon' + i]) needLoc = true;
            if (!s.dates['moon' + i]) needDate = true;
        }
        if (!needLoc && !needDate) return s.editMode ? 'Confirm Edits' : 'Add To Cart';
        if (needLoc && needDate) return 'Select Locations & Dates';
        return needLoc ? 'Select Locations' : 'Select Dates';
    }
    // Explicit repaint, for callers outside the store (the reorder swap,
    // the gallery wall hand-off). The UI repaints on store changes itself.
    window.updateHAddToCartButtonText = function () {
        setText('.h-submit__form .h-custom_text', hButtonLabel());
    };

    window.HMoonCore = {
        store: hStore,
        buttonLabel: hButtonLabel,
        goStep: function (i, opts) { navigateToStep(i, opts); },
        setFontScope: hSetFontScope,
        chooseFont: hChooseFont,
        setFonts: hSetFonts,
        setTemplate: hSetTemplate,
        setComposition: hSetComposition,
        setBackground: hSetBackground,
        setTexture: hSetTexture,
        productTypes: hProductTypes,
        sizesFor: hSizesFor,
        framesFor: hFramesFor,
        stateKey: hStateKey,
        hasFrameChoice: hHasFrameChoice,
        isPrintType: hIsPrintType,
        isUkOnlySize: hIsUkOnlySize,
        sizeAvailable: hSizeAvailable,
        sizeVariant: hSizeVariant,
        currentSelection: hCurrentSelection,
        currentVariant: hCurrentVariant,
        selectType: hSelectType,
        selectSize: hSelectSize,
        selectFrame: hSelectFrame,
        selectTypeKeepSize: hSelectTypeKeepSize,
        restoreSelection: hRestoreSelection,
        applySelection: hApplySelection,
        setGift: hSetGift
    };

    // ── Autosave / resume-draft ─────────────────────────────────────────
    // Mirrors the moon-myjs flow: debounced background draft save, plus
    // a resume modal on plain-URL revisits. funnel_status='draft' until
    // add-to-cart flips it to 'cart' and the orders/paid webhook to 'paid'.
    var hmAutosavePrimed = false;
    var hmAutosaveTimer = null;
    var HM_AUTOSAVE_DELAY_MS = 2500;

    // Edit mode only: the options tried on a carted design go to the admin's
    // cart-edit log, never h-moon-map-data, so the design that prints is left
    // alone. Same data as a save, minus the embedded canvas images.
    var hmCartEditTimer = null;
    function scheduleHmCartEditLog() {
        if (!order_id) return;
        if (hmCartEditTimer) clearTimeout(hmCartEditTimer);
        hmCartEditTimer = setTimeout(function() {
            hmCartEditTimer = null;
            try { sendToBackend(collectFormData(), 'draft', true); } catch (e) {}
        }, HM_AUTOSAVE_DELAY_MS);
    }

    function scheduleHmAutosave() {
        if (!hmAutosavePrimed) return;
        if (isEditMode) { scheduleHmCartEditLog(); return; }
        if (!order_id) return;
        if (hmAutosaveTimer) clearTimeout(hmAutosaveTimer);
        hmAutosaveTimer = setTimeout(function() {
            hmAutosaveTimer = null;
            try {
                var formData = collectFormData();
                // Write the pointer only after the save lands — an offline
                // autosave used to leave a pointer to a server row that never
                // existed, resurfacing later as a doomed "Resume?" modal.
                sendToBackend(formData, 'draft').then(function(ok) {
                    if (!ok) return;
                    try {
                        localStorage.setItem('hor_moon_last_draft', JSON.stringify({
                            orderId: order_id, ts: Date.now()
                        }));
                    } catch (e2) {}
                });
            } catch (e) { console.warn('[hor-moon] autosave error', e); }
        }, HM_AUTOSAVE_DELAY_MS);
    }

    // Explicit hook for changes that aren't a plain input/change event on a
    // tracked field — e.g. the generator's slot reorder, which rewrites a
    // dozen fields programmatically.
    window.hMoonScheduleAutosave = function() { scheduleHmAutosave(); };

    function showHmResumeModal(opts) {
        var title = opts.title || 'Resume your previous design?';
        var body = opts.body || 'We saved your last family moon design. Pick up where you left off, or start fresh.';
        var primaryLabel = opts.primaryLabel || 'Resume';
        var secondaryLabel = opts.secondaryLabel || 'Start fresh';
        var onPrimary = opts.onPrimary || function() {};
        var onSecondary = opts.onSecondary || function() {};
        // Dismissal (backdrop click / Escape) is NOT "Start fresh": it must
        // never destroy the draft pointer. A stray click outside the card
        // used to fire onSecondary and permanently lose the draft.
        var onDismiss = opts.onDismiss || function() {};
        var overlay = document.createElement('div');
        overlay.id = 'hm-resume-modal';
        overlay.innerHTML =
            '<style>' +
            '#hm-resume-modal{position:fixed;inset:0;z-index:2147483646;display:flex;align-items:center;justify-content:center;background:rgba(20,18,16,0.55);backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px);font-family:inherit;animation:hmrmFade 220ms ease-out}' +
            '#hm-resume-modal .hmrm-card{background:#f5efe6;color:#1c1a17;border-radius:14px;padding:26px 26px 22px;width:min(360px,86vw);box-shadow:0 18px 60px rgba(0,0,0,0.35);text-align:center;animation:hmrmPop 240ms cubic-bezier(.2,.9,.3,1.1)}' +
            '#hm-resume-modal h3{margin:0 0 6px;font-size:18px;font-weight:600;letter-spacing:.01em}' +
            '#hm-resume-modal p{margin:0 0 18px;font-size:13px;line-height:1.5;color:#6b6357}' +
            '#hm-resume-modal .hmrm-row{display:flex;gap:10px}' +
            '#hm-resume-modal button{flex:1;padding:11px 14px;border-radius:10px;border:1px solid #d6cdbf;background:#fff;color:#1c1a17;font:inherit;font-size:14px;cursor:pointer;transition:background 120ms,transform 120ms}' +
            '#hm-resume-modal button:hover{background:#ece4d6}' +
            '#hm-resume-modal button.hmrm-primary{background:#1c1a17;color:#f5efe6;border-color:#1c1a17}' +
            '#hm-resume-modal button.hmrm-primary:hover{background:#000}' +
            '@keyframes hmrmFade{from{opacity:0}to{opacity:1}}' +
            '@keyframes hmrmPop{from{transform:scale(.94);opacity:0}to{transform:scale(1);opacity:1}}' +
            '</style>' +
            '<div class="hmrm-card" role="dialog" aria-modal="true">' +
                '<h3></h3><p></p>' +
                '<div class="hmrm-row">' +
                    '<button type="button" class="hmrm-dismiss"></button>' +
                    '<button type="button" class="hmrm-primary"></button>' +
                '</div>' +
            '</div>';
        overlay.querySelector('h3').textContent = title;
        overlay.querySelector('p').textContent = body;
        overlay.querySelector('.hmrm-primary').textContent = primaryLabel;
        overlay.querySelector('.hmrm-dismiss').textContent = secondaryLabel;
        document.body.appendChild(overlay);
        var close = function() { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); };
        overlay.querySelector('.hmrm-primary').addEventListener('click', function() { close(); onPrimary(); });
        overlay.querySelector('.hmrm-dismiss').addEventListener('click', function() { close(); onSecondary(); });
        overlay.addEventListener('click', function(e) { if (e.target === overlay) { close(); onDismiss(); } });
        document.addEventListener('keydown', function onEsc(e) {
            if (e.key === 'Escape') {
                document.removeEventListener('keydown', onEsc, true);
                if (overlay.parentNode) { close(); onDismiss(); }
            }
        }, true);
    }

    // A row is treated as "locked" when the order has progressed to paid AND
    // the orderId doesn't carry the DUP- prefix used by the admin-side
    // duplicate route. Locked orders must not be edited from a returning
    // customizer session — that would corrupt the rendered/shipped artwork.
    function hmIsPaidLocked(row, orderId) {
        if (!row) return false;
        if (typeof orderId === 'string' && orderId.indexOf('DUP-') === 0) return false;
        // shopify_order_id is stripped by sanitizeForPublic; funnel_status
        // flips to 'paid' via the orders/paid webhook.
        return row.funnel_status === 'paid';
    }

    function hmFetchOrder(orderId) {
        return fetch(CONFIG.apiEndpoint + '/api/h-moon-map-data/?order_no=' + encodeURIComponent(orderId))
            .then(function(r) { return r.status === 200 ? r.json() : null; })
            .catch(function() { return null; });
    }

    // Fire-and-forget log of an "edit personalisations" revisit. Useful for
    // visibility into customers who returned to verify their design but
    // didn't change anything (those wouldn't produce a diff in autosave).
    function hmLogEditPersonalisationsOpened(orderId) {
        try {
            fetch(CONFIG.apiEndpoint + '/api/order-event', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    order_id: orderId,
                    event: 'edit_personalisations_opened',
                    detail: window.location.href.slice(0, 200)
                })
            }).catch(function() {});
        } catch (e) {}
    }

    function maybeShowHmResumeModal() {
        // Boot withholds autosave priming whenever a draft pointer exists (so
        // a pending modal isn't raced by a stub autosave). Every early return
        // here must therefore prime autosave itself, or the session runs with
        // autosave dead.
        try {
            var raw = localStorage.getItem('hor_moon_last_draft');
            if (!raw) return;
            var rec = null;
            try { rec = JSON.parse(raw); } catch (pe) {}
            if (!rec || !rec.orderId) {
                // Corrupt / legacy pointer — drop it and carry on fresh.
                localStorage.removeItem('hor_moon_last_draft');
                hmAutosavePrimed = true;
                return;
            }
            if (rec.ts && (Date.now() - rec.ts) > 30 * 86400000) {
                localStorage.removeItem('hor_moon_last_draft');
                hmAutosavePrimed = true;
                return;
            }
            var url = new URL(window.location.href);
            if (url.searchParams.get('order_id') ||
                url.searchParams.get('order_no') ||
                url.searchParams.get('saved') ||
                // Deep-links with a prefilled date carry their own intent —
                // don't stack an old-draft popup on top. Pointer survives
                // for the next plain visit.
                url.searchParams.get('prefill_date')) {
                hmAutosavePrimed = true;
                return;
            }
            // Resolve the saved order's status before offering to resume. A
            // paid order's draft pointer is stale — clear it silently so the
            // customer starts fresh on revisit.
            hmFetchOrder(rec.orderId).then(function(row) {
                if (!row) {
                    // Draft row is gone server-side (GC'd, never autosaved,
                    // or API unreachable). Offering "Resume" would hydrate
                    // nothing — drop the pointer instead of looping the
                    // modal on every visit.
                    console.log('[hor-moon] last draft has no server row, clearing localStorage', rec.orderId);
                    localStorage.removeItem('hor_moon_last_draft');
                    hmAutosavePrimed = true;
                    return;
                }
                if (hmIsPaidLocked(row, rec.orderId)) {
                    console.log('[hor-moon] last draft is a paid order, clearing localStorage', rec.orderId);
                    localStorage.removeItem('hor_moon_last_draft');
                    hmAutosavePrimed = true;
                    return;
                }
                // A design already in the live cart isn't a dangling draft —
                // the cart's "Edit personalisations" covers it. Cart-aware
                // copy so "start a new one" doesn't read like losing the
                // carted design.
                var inCart = cart_order_id_present.indexOf(rec.orderId) !== -1;
                showHmResumeModal({
                    title: inCart ? 'This design is in your cart' : 'Resume your previous design?',
                    body: inCart
                        ? 'Your last family moon design is already in your cart, safe and sound. Edit it here, or start a brand-new design.'
                        : 'We saved your last family moon design. Pick up where you left off, or start fresh.',
                    primaryLabel: inCart ? 'Edit cart design' : 'Resume',
                    secondaryLabel: inCart ? 'Start a new design' : 'Start fresh',
                    onPrimary: function() {
                        url.searchParams.set('order_id', rec.orderId);
                        window.location.href = url.toString();
                    },
                    onSecondary: function() {
                        localStorage.removeItem('hor_moon_last_draft');
                        hmAutosavePrimed = true;
                    },
                    // Backdrop click / Escape: keep the pointer so a refresh
                    // re-offers the draft; just let this session proceed
                    // fresh.
                    onDismiss: function() {
                        hmAutosavePrimed = true;
                    }
                });
            });
        } catch (e) {
            // Never leave the session with autosave unarmed.
            hmAutosavePrimed = true;
        }
    }

    // ============================================
    // COOKIE FUNCTIONS
    // ============================================
    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/; SameSite=Lax";
    }

    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1);
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length));
        }
        return null;
    }

    function deleteCookie(name) {
        document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    // ============================================
    // SAFE CANVAS EXPORT (Mobile-friendly)
    // ============================================
    function safeExportCanvas(moonId) {
        try {
            if (typeof window.exportHMoonCanvas !== 'function') {
                console.warn('⚠️ exportHMoonCanvas function not available');
                return '';
            }

            // Call without size params - let the function auto-detect mobile
            var result = window.exportHMoonCanvas(moonId);

            // Ensure we always return a string
            if (typeof result !== 'string') {
                console.warn('⚠️ Canvas export for moon ' + moonId + ' returned non-string:', typeof result);
                return '';
            }

            // Validate the data URL format
            if (result && !result.startsWith('data:image/')) {
                console.warn('⚠️ Canvas export for moon ' + moonId + ' returned invalid data URL');
                return '';
            }

            return result;
        } catch (error) {
            console.error('❌ Safe canvas export failed for moon ' + moonId + ':', error.message);
            return '';
        }
    }

    // ============================================
    // FIELD SHAKE HELPER
    // ============================================
    function flashField(element) {
        if (!element) {
            console.warn('flashField: Element not found');
            return;
        }

        // Store original transform
        const originalTransform = getComputedStyle(element).transform;

        // Relaxed, inviting shake animation - gentle sway effect
        const shakeSequence = [
            { offset: 0, transform: 'translateX(0px)' },
            { offset: 0.15, transform: 'translateX(-5px)' },
            { offset: 0.30, transform: 'translateX(5px)' },
            { offset: 0.45, transform: 'translateX(-4px)' },
            { offset: 0.60, transform: 'translateX(4px)' },
            { offset: 0.75, transform: 'translateX(-2px)' },
            { offset: 0.90, transform: 'translateX(2px)' },
            { offset: 1.0, transform: 'translateX(0px)' }
        ];

        // Apply shake using Web Animations API (smooth and performant)
        if (element.animate) {
            element.animate(
                shakeSequence.map(step => ({ transform: step.transform })),
                {
                    duration: 900, // Slower, more relaxed timing
                    easing: 'ease-in-out'
                }
            );
        } else {
            // Fallback for browsers without the Web Animations API
            let step = 0;
            const shakeInterval = setInterval(() => {
                if (step >= shakeSequence.length) {
                    clearInterval(shakeInterval);
                    element.style.transform = originalTransform;
                    return;
                }
                element.style.transform = shakeSequence[step].transform;
                step++;
            }, 112); // ~900ms total (112ms * 8 steps)
        }

        console.log('✨ Shaking field:', element.getAttribute('id') || element.getAttribute('class'));
    }

    // ============================================
    // NAVIGATION HELPER
    // Track current step index independently (fixes mobile sync issues)
    // ============================================
    let stepScrollRequest = 0;

    function scrollHorizontalMoonStepIntoView() {
        if (!window.matchMedia || !window.matchMedia('(max-width: 991px)').matches) return;
        const side = document.querySelector('.h-app__wrapper > .h-app__side');
        if (!side) return;
        const request = ++stepScrollRequest;
        window.requestAnimationFrame(function() {
            window.requestAnimationFrame(function() {
                if (request !== stepScrollRequest) return;
                const targetY = Math.max(0, (window.scrollY || window.pageYOffset || 0) + side.getBoundingClientRect().top - 8);
                const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                window.scrollTo({ top: targetY, behavior: reducedMotion ? 'auto' : 'smooth' });
            });
        });
    }

    // The step lives in the store; hor-moon-ui.js paints the tabs, the
    // open panel and the Next / submit buttons from it.
    function stepCount() { return qa('.cust-step-nav .cust-step-tab').length || 4; }
    function navigateToStep(stepIndex, options) {
        options = options || {};
        var n = stepCount();
        if (stepIndex < 0) stepIndex = 0;
        if (stepIndex >= n) stepIndex = n - 1;
        var s = hStore();
        var previousIndex = s.step;
        s.step = stepIndex;
        if (stepIndex !== previousIndex && options.scroll) scrollHorizontalMoonStepIntoView();
    }
    window.hMoonGoStep = navigateToStep;

    // ============================================
    // SETUP NAVIGATION
    // ============================================
    function setupNavigation() {
        const tabs = qa('.cust-step-nav .cust-step-tab');

        // Tab clicks
        tabs.forEach(function (tab) {
            tab.addEventListener('click', function(e) {
                e.preventDefault();
                // Index among the TABS, not the nav's children: SkylitTabPill
                // inserts its sliding indicator as the nav's first child.
                const clickedIndex = tabs.indexOf(this);
                console.log('🔹 Tab clicked:', clickedIndex);
                navigateToStep(clickedIndex, { scroll: true });
            });
        });

        // Next button clicks
        qa('.h-next__step').forEach(function (btn) {
            btn.addEventListener('click', function(e) {
                e.preventDefault();
                const nextIndex = hStore().step + 1;
                if (nextIndex < tabs.length) {
                    navigateToStep(nextIndex, { scroll: true });
                }
            });
        });

        // Header clicks (accordion style for desktop)
        qa('.h-head__settings').forEach(function (head) {
            head.addEventListener('click', function(e) {
                e.preventDefault();
                const setting = this.closest('.h-element__settings');
                const settingIndex = qa('.h-element__settings').indexOf(setting);
                navigateToStep(settingIndex, { scroll: true });
            });
        });

        console.log('✅ H-Moon navigation initialized');
    }

    // ============================================
    // INITIALIZE ON DOCUMENT READY
    // ============================================
    onReady(function() {
        console.log('H-Moon Form Handler initialized');
        setupFormSubmission();
        setupNavigation();

        // Fetch cart to track existing orders
        fetchCartAndCheckForEdit();

        // ── Autosave triggers ─────────────────────────────────────────────
        // Delegated listeners on common h-moon customizer inputs/clicks. The
        // debounce inside scheduleHmAutosave coalesces rapid changes.
        delegate(
            'input change',
            '#h-textTitle, #h-textSubtitle, ' +
            '#h-custom_date_moon1, #h-custom_date_moon2, #h-custom_date_moon3, #h-custom_date_moon4, ' +
            '#h-custom_location_moon1, #h-custom_location_moon2, #h-custom_location_moon3, #h-custom_location_moon4, ' +
            '.h-show-time-cb, ' +
            '.h-moon-name, .h-moon-date, .h-moon-time',
            scheduleHmAutosave
        );
        delegate('click', '.h-elem__picker, .h-template-option, .h-moon-card', function() {
            // Defer so the click handler that flips active__picker has finished
            // before the debounce reads the new state.
            setTimeout(scheduleHmAutosave, 50);
        });

        // ── Global date display format (step 2 "Date format" cycle) ──────
        // Preview labels and the saved/printed date string both follow this.
        var HM_DATE_FORMATS = ['written', 'numeric', 'plain', 'us'];
        window.hMoonSetDateFormat = function(format, silent) {
            if (HM_DATE_FORMATS.indexOf(format) === -1) return;
            window.hMoonDateFormat = format;
            if (typeof window.hMoonReformatAllDates === 'function') {
                window.hMoonReformatAllDates();
            }
            var dateLabel = q('#h-moon-date-1');
            var sample = (dateLabel ? dateLabel.textContent.trim() : '') ||
                (window.formatHMoonDate ? window.formatHMoonDate(14, 2, 2023) : '');
            setText('#h-date-format-sample', sample);
            if (!silent) scheduleHmAutosave();
        };
        delegate('click', '#h-date-format-cycle', function() {
            var idx = HM_DATE_FORMATS.indexOf(window.hMoonDateFormat || 'written');
            window.hMoonSetDateFormat(HM_DATE_FORMATS[(idx + 1) % HM_DATE_FORMATS.length]);
        });

        // ============================================
        // LOCATION AND DATE TRACKING
        // ============================================
        // The store's locations / dates flags drive the button label
        // (hButtonLabel, painted by hor-moon-ui.js).
        function checkHLocationStatus(moonId) {
            const locationText = val('#h-address_form1_moon' + moonId).trim();
            window.hUserEnteredLocations['moon' + moonId] = !!locationText;
        }

        // Dates only count once the customer changes the selectors (they
        // start on a default).
        function markHDateAsSelected(moonId) {
            window.hUserSelectedDates['moon' + moonId] = true;
        }

        // Listen for location input changes for all moons
        delegate('input change', '.h-address-input', function() {
            const moonId = this.getAttribute('data-moon');
            if (moonId) {
                checkHLocationStatus(moonId);
            }
        });

        // Listen for date selector changes for all moons - only mark as selected when user changes them
        delegate('change', '.h-bear-dates, .h-bear-months, .h-bear-years', function() {
            const moonId = this.getAttribute('data-moon');
            if (moonId) {
                markHDateAsSelected(moonId);
            }
        });

        // Listen for custom location edits
        delegate('input', '#h-custom_location_moon1, #h-custom_location_moon2, #h-custom_location_moon3, #h-custom_location_moon4', function() {
            const id = this.getAttribute('id');
            const moonId = id.replace('h-custom_location_moon', '');
            const customLocation = this.value.trim();

            // Update the main address field AND the hidden custom_address
            // field. collectFormData reads custom_address first, and both
            // hydration (loadHMoonMapData) and autocomplete place_changed
            // write it — without this sync a Location Text edit is silently
            // discarded on save and reverts on the next reload.
            setVal('#h-address_form1_moon' + moonId, customLocation);
            setVal('#h-custom_address_moon' + moonId, customLocation);

            checkHLocationStatus(moonId);
        });

        // A location already in a field on load (browser form restore)
        // counts. Dates don't: the selectors start on a default.
        setTimeout(function() {
            for (let i = 1; i <= 4; i++) {
                if (val('#h-address_form1_moon' + i).trim()) window.hUserEnteredLocations['moon' + i] = true;
            }
        }, 500);

        // Print's gift-tile rules (no Gift Wrap / Bundle) live in HMoonCore
        // (hApplySelection) and the section's Alpine bindings.
    });

    // ============================================
    // FETCH CART AND CHECK FOR EDIT MODE
    // ============================================
    // Add-to-cart redirects to /cart, so pressing Back restores this page from
    // the back-forward cache with the pre-add cart snapshot still in memory.
    // Re-read the live cart on restore so edit mode and the button label stay
    // honest (the add path purges by live cart state regardless).
    window.addEventListener('pageshow', function(event) {
        if (!event.persisted) return;
        fetch(window.Shopify.routes.root + 'cart.js', { credentials: 'same-origin' })
            .then(function(r) { return r.json(); })
            .then(function(cart) {
                cart_order_id_present.length = 0;
                cart_order_id_present_id.length = 0;
                (cart.items || []).forEach(function(item) {
                    var props = item.properties || {};
                    var oid = props._OrderID || props.OrderID;
                    if (!oid || props['Product Type'] !== CONFIG.productType) return;
                    cart_order_id_present.push(oid);
                    cart_order_id_present_id.push(item.key);
                });
                setEditMode(cart_order_id_present.indexOf(order_id) !== -1);
                console.log('[hor-moon] bfcache restore — cart re-read, editMode=' + isEditMode);
            })
            .catch(function(e) { console.warn('[hor-moon] bfcache cart re-read failed', e); });
    });

    function fetchCartAndCheckForEdit() {
        // Use XMLHttpRequest with /cart.json as fetch/$.getJSON to /cart.js can be blocked
        var cartXhr = new XMLHttpRequest();
        cartXhr.open('GET', window.Shopify.routes.root + 'cart.json', true);
        cartXhr.timeout = 5000;

        cartXhr.onload = function() {
            if (cartXhr.status === 200) {
                try {
                    var cart = JSON.parse(cartXhr.responseText);
                    // Track existing H-Moon orders in cart
                    if (cart.items && cart.items.length > 0) {
                        cart.items.forEach(function(item) {
                            // Support both new (_OrderID) and legacy (OrderID) formats
                            var orderId = item.properties && (item.properties._OrderID || item.properties.OrderID);
                            if (orderId && item.properties['Product Type'] === CONFIG.productType) {
                                cart_order_id_present.push(orderId);
                                cart_order_id_present_id.push(item.key);
                            }
                        });
                    }
                    console.log("H-Moon cart items loaded:", cart_order_id_present.length, "orders found");
                } catch (e) {
                    console.warn('Error parsing cart data:', e);
                }
            }

            // Check for order_id or order_no in URL (editing existing order)
            var urlParams = new URLSearchParams(window.location.search);
            var existingOrderId = urlParams.get('order_id') || urlParams.get('order_no');

            if (existingOrderId) {
                console.log('🌙 Edit mode - Loading existing H-Moon order:', existingOrderId);
                // Refuse to hydrate a paid order — see hmIsPaidLocked. Drop
                // the URL param and reload as a fresh customizer session.
                hmFetchOrder(existingOrderId).then(function(row) {
                    if (hmIsPaidLocked(row, existingOrderId)) {
                        console.log('[hor-moon] paid order revisited, starting fresh', existingOrderId);
                        try { localStorage.removeItem('hor_moon_last_draft'); } catch (e) {}
                        var p = new URLSearchParams(window.location.search);
                        p.delete('order_id'); p.delete('order_no');
                        var qs = p.toString();
                        window.location.replace(window.location.pathname + (qs ? '?' + qs : ''));
                        return;
                    }
                    // Edit mode only when the design is actually in the live
                    // cart — a resumed draft / save-for-later link is a plain
                    // editing session: normal add-to-cart copy and autosave
                    // stays on (isEditMode disables it).
                    setEditMode(cart_order_id_present.indexOf(existingOrderId) !== -1);
                    if (isEditMode) hmLogEditPersonalisationsOpened(existingOrderId);
                    waitForGeneratorReady(function() {
                        loadHMoonMapData(existingOrderId);
                        // A frame bought from the cart's "Complete the look"
                        // upsell (A4 family moons): show it as the Framed
                        // selection so the customer sees the frame they own.
                        // Runs after the hydrator's staggered variant restore
                        // (~1.1s of internal timers). The submit handler keeps
                        // the two-line structure via SkylitPairing.syncFrameAddon.
                        if (isEditMode && window.SkylitPairing && window.SkylitPairing.pairedFrame) {
                            window.SkylitPairing.pairedFrame(existingOrderId).then(function(f) {
                                if (!f) return;
                                setTimeout(function() {
                                    if (window.HMoonCore.store().type !== "Print") return;
                                    hmFrameFromAddon = true;
                                    window.HMoonCore.selectTypeKeepSize("Framed", f.colour);
                                }, 1800);
                            });
                        }
                    });
                });
            } else {
                // No order in URL, check for saved data in cookies
                loadSavedData();
                // Plain URL — offer to resume the last saved draft if any.
                setTimeout(maybeShowHmResumeModal, 800);
            }
            // Activate autosave once boot has settled — but skip when a resume
            // modal is pending; the modal's branches prime autosave themselves
            // so we don't persist a stub server-side order before the customer
            // picks Continue or Start fresh.
            var hmHasDraftA = false;
            try { hmHasDraftA = !!localStorage.getItem('hor_moon_last_draft'); } catch (e) {}
            if (!hmHasDraftA || existingOrderId) {
                setTimeout(function() { hmAutosavePrimed = true; }, 1500);
            }
        };

        cartXhr.onerror = function() {
            console.warn('Failed to fetch cart, continuing without cart tracking');
            handleCartFetchError();
        };

        cartXhr.ontimeout = function() {
            console.warn('Cart fetch timed out, continuing without cart tracking');
            handleCartFetchError();
        };

        cartXhr.send();

        function handleCartFetchError() {
            // Still check for edit mode
            var urlParams = new URLSearchParams(window.location.search);
            var existingOrderId = urlParams.get('order_id') || urlParams.get('order_no');

            if (existingOrderId) {
                hmFetchOrder(existingOrderId).then(function(row) {
                    if (hmIsPaidLocked(row, existingOrderId)) {
                        console.log('[hor-moon] paid order revisited (xhr error path), starting fresh', existingOrderId);
                        try { localStorage.removeItem('hor_moon_last_draft'); } catch (e) {}
                        var p = new URLSearchParams(window.location.search);
                        p.delete('order_id'); p.delete('order_no');
                        var qs = p.toString();
                        window.location.replace(window.location.pathname + (qs ? '?' + qs : ''));
                        return;
                    }
                    setEditMode(true);
                    hmLogEditPersonalisationsOpened(existingOrderId);
                    waitForGeneratorReady(function() {
                        loadHMoonMapData(existingOrderId);
                        // A frame bought from the cart's "Complete the look"
                        // upsell (A4 family moons): show it as the Framed
                        // selection so the customer sees the frame they own.
                        // Runs after the hydrator's staggered variant restore
                        // (~1.1s of internal timers). The submit handler keeps
                        // the two-line structure via SkylitPairing.syncFrameAddon.
                        if (isEditMode && window.SkylitPairing && window.SkylitPairing.pairedFrame) {
                            window.SkylitPairing.pairedFrame(existingOrderId).then(function(f) {
                                if (!f) return;
                                setTimeout(function() {
                                    if (window.HMoonCore.store().type !== "Print") return;
                                    hmFrameFromAddon = true;
                                    window.HMoonCore.selectTypeKeepSize("Framed", f.colour);
                                }, 1800);
                            });
                        }
                    });
                });
            } else {
                loadSavedData();
                setTimeout(maybeShowHmResumeModal, 800);
            }
            var hmHasDraftB = false;
            try { hmHasDraftB = !!localStorage.getItem('hor_moon_last_draft'); } catch (e) {}
            if (!hmHasDraftB || existingOrderId) {
                setTimeout(function() { hmAutosavePrimed = true; }, 1500);
            }
        }
    }

    // ============================================
    // WAIT FOR GENERATOR TO BE READY
    // ============================================
    function waitForGeneratorReady(callback) {
        // 30s max wait (300 * 100ms). On slow/cold loads the generator can
        // take well over 5s to boot; hydrating before it is ready lets its
        // init stomp the hydrated state (template count, font) and a later
        // save then wipes moons 3/4 from the order. The proceed-anyway
        // fallback only remains for a generator that never boots at all.
        var maxAttempts = 300;
        var attempts = 0;

        function checkReady() {
            attempts++;
            if (window.hMoonGeneratorReady) {
                console.log('✅ Generator ready after ' + (attempts * 100) + 'ms');
                callback();
            } else if (attempts < maxAttempts) {
                setTimeout(checkReady, 100);
            } else {
                console.warn('⚠️ Generator not ready after 5s, proceeding anyway');
                callback();
            }
        }

        checkReady();
    }

    // ============================================
    // (Removed 2026-07-10: the ~420-line client-canvas cart-thumbnail
    // pipeline — generateHMoonCompositeThumbnail, _hmCompositeIntoMockup,
    // HM_MF_* mockup consts and overlay preloading. Cart thumbnails render
    // server-side via CF Browser Rendering; the mockup cutout fractions
    // live on in skylit-admin/app/lib/hor-moon-thumbnail-render.ts, which
    // ported them VERBATIM from the deleted _hmCompositeIntoMockup.)
    // ============================================

    // ============================================
    // FORM SUBMISSION HANDLER
    // ============================================
    function setupFormSubmission() {
        var hmAtcMorphed = false;   // the add-to-cart button is mid-morph (skylit-motion.js)
        qa('.h-submit__form').forEach(function (submitEl) { submitEl.addEventListener('click', function(e) {
            e.preventDefault();

            var btn = this;
            if (getComputedStyle(btn).pointerEvents === 'none') {
                console.log('Button disabled, ignoring click');
                return;
            }

            // Check if all required locations and dates are entered
            const templateCount = window.hMoonTemplateCount || 2;
            let missingLocations = [];
            let missingDates = [];

            for (let i = 1; i <= templateCount; i++) {
                if (!window.hUserEnteredLocations['moon' + i]) {
                    missingLocations.push('Moon ' + i);
                }
                if (!window.hUserSelectedDates['moon' + i]) {
                    missingDates.push('Moon ' + i);
                }
            }

            if (missingLocations.length > 0 || missingDates.length > 0) {
                console.log('❌ Cannot submit - missing:', { locations: missingLocations, dates: missingDates });

                // Navigate to step 1 (Moment) where locations and dates can be entered
                navigateToStep(1, { scroll: true });

                // Wait for navigation to complete, then flash the missing fields.
                // Flash the VISIBLE controls: the location mirror
                // #h-address_form1_moonN is type="hidden" (the Places box renders
                // its own input) and the date selects sit in a display:none row
                // behind the picker trigger, so shaking either was invisible and
                // the customer got bounced back to this step with no cue at all.
                setTimeout(() => {
                    var missing = [];
                    for (let i = 1; i <= templateCount; i++) {
                        var needLoc = !window.hUserEnteredLocations['moon' + i];
                        var needDate = !window.hUserSelectedDates['moon' + i];
                        if (needLoc || needDate) missing.push({ i: i, loc: needLoc, date: needDate });
                    }
                    if (!missing.length) return;

                    // A collapsed card hides the field being shaken — open the
                    // first incomplete moon's card before flashing.
                    var hdr = q('.h-moon-card-header[data-accordion-toggle="' + missing[0].i + '"]');
                    if (hdr && hdr.classList.contains('h-collapsed')) hdr.click();

                    var msgs = [];
                    missing.forEach(function(m) {
                        if (m.loc) {
                            var pacEl = document.getElementById('h-moon-location-input-' + m.i);
                            var typed = pacEl ? (pacEl.value || '').trim() : '';
                            var mirror = q('#h-address_form1_moon' + m.i);
                            flashField(pacEl || (mirror && mirror.parentElement));
                            // Typed but never tapped a suggestion: the location only
                            // counts once a Places result is selected (that is what
                            // writes the mirror and places the moon). Say so.
                            msgs.push(typed
                                ? 'Moon ' + m.i + ': tap a suggestion from the list to set its location'
                                : 'Moon ' + m.i + ' needs a location');
                        }
                        if (m.date) {
                            var trig = q('.h-date-picker-trigger[data-moon="' + m.i + '"]');
                            var daySel = q('.h-bear-dates[data-moon="' + m.i + '"]');
                            flashField(trig || (daySel && daySel.parentElement));
                            msgs.push('Moon ' + m.i + ' needs a date');
                        }
                    });
                    showErrorNotification(msgs.join('<br>'));
                }, 300);

                return;
            }

            // Frame adopted from the cart add-on: keep the two-line
            // structure. Flip the selection back to Print (so #h-var_id and
            // the _selected_* properties follow), then re-run the submit.
            if (hmFrameFromAddon && !hmFrameFlipDone) {
                var hmSel = window.HMoonCore.currentSelection();
                if (hmSel.type === "Framed") {
                    hmAddonFrameColour = hmSel.frame || "Black";
                    window.HMoonCore.selectTypeKeepSize("Print");
                } else {
                    hmAddonFrameColour = null;
                }
                hmFrameFlipDone = true;
                var hmBtn = this;
                setTimeout(function() { hmBtn.click(); }, 0);
                return;
            }

            // Disable the button; it morphs itself (skylit-motion.js): pill ->
            // spinner -> tick -> "Added". The preview loader and "Processing..."
            // label are the fallback when the morph can't run.
            btn.style.pointerEvents = 'none';
            hmAtcMorphed = !!(window.SkylitAtcMorph && window.SkylitAtcMorph.start(btn, isEditMode ? 'Updating…' : 'Adding…'));
            if (!hmAtcMorphed) {
                qa('.h-custom_text', btn).forEach(function (t) { t.textContent = 'Processing...'; });
                fadeIn('.myloader', 200);
            }

            // Collect all form data
            var formData = collectFormData();
            console.log('H-Moon Form Data:', formData);

            // Client-canvas composite thumbnail generation deliberately
            // SKIPPED here. Family-moon cart thumbnails render server-side
            // via CF Browser Rendering (_thumbnail_final -> /api/cart-thumbnail-img/),
            // same as single moon (moon-myjs.js:submit_form neutered this on
            // 2026-06-27 with `const compositeThumbnail = null;`). Writing a
            // `thumbnail_<orderId>` localStorage entry here made
            // upgradeCartBackendThumbnails() in main-cart-items.liquid treat
            // the client canvas render as authoritative ("Custom-print with
            // localStorage thumbnail - using as final (no upgrade)") and
            // PERMANENTLY skip swapping in the real CF thumbnail on the cart
            // page — this was the family cart-thumbnail bug. Do not
            // reintroduce localStorage.setItem(`thumbnail_${order_id}`, ...)
            // or window.skylitUploadCartThumbnail(...) on this path.
            submitFormData(formData, btn);
        }); });

        // Helper function to handle form submission
        function submitFormData(formData, btn) {
            // Save to cookie for persistence
            saveDataToCookie(formData);

            // Add to Shopify cart
            addToCart(formData)
                .then(function(response) {
                    console.log('Added to cart successfully');
                    // The morphed button says it itself; the toast is the fallback.
                    if (!hmAtcMorphed) showSuccessNotification(isEditMode ? 'Edits confirmed!' : 'Added to cart!');
                    // Log confirm in edit mode so admin's activity feed
                    // can pair with the earlier opened event.
                    if (isEditMode) {
                        try {
                            fetch(CONFIG.apiEndpoint + '/api/order-event', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({
                                    order_id: formData.order_id,
                                    event: 'edit_personalisations_confirmed',
                                    detail: window.location.href.slice(0, 200)
                                })
                            }).catch(function() {});
                        } catch (e) {}
                    }
                    if (hmAtcMorphed) window.SkylitAtcMorph.success(isEditMode ? 'Updated' : 'Added');
                    setTimeout(function() {
                        // Sync the frame add-on line to the confirmed
                        // selection (or remove it if deselected).
                        if (hmFrameFromAddon && window.SkylitPairing && window.SkylitPairing.syncFrameAddon) {
                            window.SkylitPairing.syncFrameAddon(formData.order_id, hmAddonFrameColour)
                                .then(function() { window.location.href = window.SkylitGalleryWall ? window.SkylitGalleryWall.destination() : '/cart'; },
                                      function() { window.location.href = window.SkylitGalleryWall ? window.SkylitGalleryWall.destination() : '/cart'; });
                        } else {
                            window.location.href = window.SkylitGalleryWall ? window.SkylitGalleryWall.destination() : '/cart';
                        }
                    }, hmAtcMorphed ? 850 : 500);   // long enough for the tick to read
                })
                .catch(function(error) {
                    console.error('Add to cart failed:', error);
                    showErrorNotification('Failed to add to cart. Please try again.');
                    if (hmAtcMorphed) { window.SkylitAtcMorph.reset(); hmAtcMorphed = false; }
                    btn.style.pointerEvents = 'auto';
                    qa('.h-custom_text', btn).forEach(function (t) { t.textContent = 'Add To Cart'; });
                    fadeOut('.myloader', 300);
                });
        }
    }

    // ============================================
    // COLLECT ALL FORM DATA
    // ============================================
    function collectFormData() {
        // Get template count (2/3/4 moons)
        var templateCount = window.hMoonTemplateCount || 2;

        // Get data from all moons via generator
        var moon1Data = window.getHMoonData ? window.getHMoonData(1) : {};
        var moon2Data = window.getHMoonData ? window.getHMoonData(2) : {};
        var moon3Data = templateCount >= 3 && window.getHMoonData ? window.getHMoonData(3) : {};
        var moon4Data = templateCount >= 4 && window.getHMoonData ? window.getHMoonData(4) : {};

        // Get background and font from generator
        var background = window.hMoonBackground || 'family3';
        var font = window.hMoonFont || 'Spectral';
        // Details font = the per-moon name/date/location scope. Submitted
        // separately so the renderer can mirror the customizer's font-scope
        // split (message vs details); falls back to the message font, then
        // Josefin Sans, matching applyFont()'s defaults in hor-moon-generator.js.
        var detailsFont = window.hMoonDetailsFont || window.hMoonFont || 'Josefin Sans';

        // Composition (classic / banner / bottom-caption / quad-portrait), so
        // the backend renderer knows how to lay out title, subtitle, and
        // per-moon labels.
        var composition = hStore().composition || 'classic';

        // Text fields - respect empty values (no defaults)
        var title = val('#h-textTitle') || '';
        var subtitle = val('#h-textSubtitle') || '';
        var moon1Name = val('#h-moon1Name') || '';
        var moon2Name = val('#h-moon2Name') || '';
        var moon3Name = templateCount >= 3 ? (val('#h-moon3Name') || '') : '';
        var moon4Name = templateCount >= 4 ? (val('#h-moon4Name') || '') : '';

        // Moon 1 details
        var moon1Location = val('#h-custom_address_moon1') || val('#h-address_form1_moon1') || 'London, UK';
        var moon1Date = displayedDateText(1);
        var moon1Time = formatTimeFromSelectors(1);
        var moon1IsoTimestamp = createIsoTimestamp(1, moon1Data);

        // Moon 2 details
        var moon2Location = val('#h-custom_address_moon2') || val('#h-address_form1_moon2') || 'Manchester, UK';
        var moon2Date = displayedDateText(2);
        var moon2Time = formatTimeFromSelectors(2);
        var moon2IsoTimestamp = createIsoTimestamp(2, moon2Data);

        // Moon 3 details (if applicable)
        var moon3Location = templateCount >= 3 ? (val('#h-custom_address_moon3') || val('#h-address_form1_moon3') || '') : '';
        var moon3Date = templateCount >= 3 ? displayedDateText(3) : '';
        var moon3Time = templateCount >= 3 ? formatTimeFromSelectors(3) : '';
        var moon3IsoTimestamp = templateCount >= 3 ? createIsoTimestamp(3, moon3Data) : '';

        // Moon 4 details (if applicable)
        var moon4Location = templateCount >= 4 ? (val('#h-custom_address_moon4') || val('#h-address_form1_moon4') || '') : '';
        var moon4Date = templateCount >= 4 ? displayedDateText(4) : '';
        var moon4Time = templateCount >= 4 ? formatTimeFromSelectors(4) : '';
        var moon4IsoTimestamp = templateCount >= 4 ? createIsoTimestamp(4, moon4Data) : '';

        // Product options (option1 = Framed / Print / Canvas)
        var hmSelNow = window.HMoonCore.currentSelection();
        var productType = hmSelNow.type || '';
        var productTypeLower = productType.toLowerCase();

        // Check if it's a framed product (Black, White, Natural, or contains "Framed")
        var isFramed = productTypeLower.includes('black') ||
                       productTypeLower.includes('white') ||
                       productTypeLower.includes('natural') ||
                       productTypeLower.includes('framed');

        // Get frame color:
        // - For "Black", "White", "Natural" product types, the frame color IS the product type
        // - For "Framed" product type, get from the visible frame picker
        var frameStyle = 'None';
        if (isFramed) {
            if (productTypeLower.includes('black')) {
                frameStyle = 'Black';
            } else if (productTypeLower.includes('white')) {
                frameStyle = 'White';
            } else if (productTypeLower.includes('natural')) {
                frameStyle = 'Natural';
            } else {
                frameStyle = hmSelNow.frame || 'Black';
            }
        }

        var size = hmSelNow.size || '40x50cm';

        // Debug logging for size selection
        console.log('📏 Size selected:', size, '| Product type:', productType, '| Frame style:', frameStyle);

        // Variant ID
        var variantId = val('#h-var_id');

        // Get canvas data for fallback (if server-side render fails)
        // Note: exportHMoonCanvas now auto-detects mobile and adjusts size accordingly
        var moon1Canvas = safeExportCanvas(1);
        var moon2Canvas = safeExportCanvas(2);
        var moon3Canvas = templateCount >= 3 ? safeExportCanvas(3) : '';
        var moon4Canvas = templateCount >= 4 ? safeExportCanvas(4) : '';

        return {
            // Product identification
            product_type: CONFIG.productType,
            variant_id: variantId,
            order_id: order_id,

            // Template and styling
            template_count: templateCount,
            background: background,
            font: font,
            details_font: detailsFont,
            composition: composition,

            // Text content
            title: title,
            subtitle: subtitle,

            // Moon 1
            moon1_name: moon1Name,
            moon1_date: moon1Date,
            moon1_time: moon1Time,
            moon1_location: moon1Location,
            moon1_lat: moon1Data.location ? moon1Data.location.lat : 51.5074,
            moon1_lng: moon1Data.location ? moon1Data.location.lng : -0.1278,
            moon1_phase: moon1Data.phaseInfo ? moon1Data.phaseInfo.phaseName : '',
            moon1_illumination: moon1Data.phaseInfo ? moon1Data.phaseInfo.illumination : 0,
            moon1_iso_timestamp: moon1IsoTimestamp,
            moon1_canvas_data: moon1Canvas,

            // Moon 2
            moon2_name: moon2Name,
            moon2_date: moon2Date,
            moon2_time: moon2Time,
            moon2_location: moon2Location,
            moon2_lat: moon2Data.location ? moon2Data.location.lat : 53.4808,
            moon2_lng: moon2Data.location ? moon2Data.location.lng : -2.2426,
            moon2_phase: moon2Data.phaseInfo ? moon2Data.phaseInfo.phaseName : '',
            moon2_illumination: moon2Data.phaseInfo ? moon2Data.phaseInfo.illumination : 0,
            moon2_iso_timestamp: moon2IsoTimestamp,
            moon2_canvas_data: moon2Canvas,

            // Moon 3 (if template_count >= 3)
            moon3_name: moon3Name,
            moon3_date: moon3Date,
            moon3_time: moon3Time,
            moon3_location: moon3Location,
            moon3_lat: moon3Data.location ? moon3Data.location.lat : 0,
            moon3_lng: moon3Data.location ? moon3Data.location.lng : 0,
            moon3_phase: moon3Data.phaseInfo ? moon3Data.phaseInfo.phaseName : '',
            moon3_illumination: moon3Data.phaseInfo ? moon3Data.phaseInfo.illumination : 0,
            moon3_iso_timestamp: moon3IsoTimestamp,
            moon3_canvas_data: moon3Canvas,

            // Moon 4 (if template_count >= 4)
            moon4_name: moon4Name,
            moon4_date: moon4Date,
            moon4_time: moon4Time,
            moon4_location: moon4Location,
            moon4_lat: moon4Data.location ? moon4Data.location.lat : 0,
            moon4_lng: moon4Data.location ? moon4Data.location.lng : 0,
            moon4_phase: moon4Data.phaseInfo ? moon4Data.phaseInfo.phaseName : '',
            moon4_illumination: moon4Data.phaseInfo ? moon4Data.phaseInfo.illumination : 0,
            moon4_iso_timestamp: moon4IsoTimestamp,
            moon4_canvas_data: moon4Canvas,

            // Product options
            product_option: productType || 'Print Only', // Actual product type (Black, White, Natural, Canvas, Print Only, etc.)
            frame_style: frameStyle,
            size: size,

            // Gift selection, from the store. Used both
            // to push a paired gift line item to /cart/add and to write
            // gift_option onto the horizontal_moon_maps row so fulfilment
            // PDFs reflect the customer's selection.
            gift_option: readGiftOptionFromUI(),

            // Moon texture variants (per-moon)
            moon_texture: window.currentHMoonTexture || 'silver',
            moon1_texture: (window.hMoonTextures && window.hMoonTextures[1]) || 'silver',
            moon2_texture: (window.hMoonTextures && window.hMoonTextures[2]) || 'silver',
            moon3_texture: templateCount >= 3 ? ((window.hMoonTextures && window.hMoonTextures[3]) || 'silver') : 'silver',
            moon4_texture: templateCount >= 4 ? ((window.hMoonTextures && window.hMoonTextures[4]) || 'silver') : 'silver',

            // Timestamp
            created_at: new Date().toISOString()
        };
    }

    // ============================================
    // CREATE ISO TIMESTAMP FROM DATE SELECTORS
    // ============================================
    function createIsoTimestamp(moonId, moonData) {
        // If moonData has a date object, use it
        if (moonData && moonData.date instanceof Date) {
            return moonData.date.toISOString();
        }

        // Otherwise create from selectors
        var day = parseInt(val('.h-bear-dates[data-moon="' + moonId + '"]')) || 1;
        var month = parseInt(val('.h-bear-months[data-moon="' + moonId + '"]')) || 0;
        var year = parseInt(val('.h-bear-years[data-moon="' + moonId + '"]')) || new Date().getFullYear();
        // isNaN, not `||`: `parseInt('0') || 21` is 21, so a midnight or
        // on-the-hour selection silently became 21:00 in the saved instant.
        // Fallback is the customizer default, 11:11 PM.
        var hoursRaw = parseInt(val('.h-moon-hours[data-moon="' + moonId + '"]'));
        var hours = isNaN(hoursRaw) ? 23 : hoursRaw;
        var minutesRaw = parseInt(val('.h-moon-minutes[data-moon="' + moonId + '"]'));
        var minutes = isNaN(minutesRaw) ? 11 : minutesRaw;

        var date = new Date(year, month, day, hours, minutes, 0);
        return date.toISOString();
    }

    // ============================================
    // FORMAT DATE/TIME FROM SELECTORS
    // ============================================
    // The printed date = exactly what the preview label shows. The label
    // follows the global date-format selection (and any manual Custom Date
    // Text edit); saving the dropdown-derived numeric string instead is how
    // prints ended up with "14/03/2023" while the customer approved
    // "14th March, 2023" on screen. Moon-phase math is unaffected — it runs
    // off the iso_timestamp built from the selectors, not this text.
    function displayedDateText(moonId) {
        var el = document.getElementById('h-moon-date-' + moonId);
        if (el) return el.textContent.trim();
        return formatDateFromSelectors(moonId);
    }

    function formatDateFromSelectors(moonId) {
        var day = val('.h-bear-dates[data-moon="' + moonId + '"]') || '1';
        var month = parseInt(val('.h-bear-months[data-moon="' + moonId + '"]')) + 1 || 1;
        var year = val('.h-bear-years[data-moon="' + moonId + '"]') || new Date().getFullYear();

        return day.toString().padStart(2, '0') + '/' + month.toString().padStart(2, '0') + '/' + year;
    }

    function formatTimeFromSelectors(moonId) {
        var hours = val('.h-moon-hours[data-moon="' + moonId + '"]') || '23';
        var minutes = val('.h-moon-minutes[data-moon="' + moonId + '"]') || '11';

        return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0');
    }

    // ============================================
    // ADD TO SHOPIFY CART
    // ============================================
    function addToCart(formData) {
        return new Promise(function(resolve, reject) {
            var variantId = formData.variant_id;

            if (!variantId) {
                reject(new Error('No variant ID found'));
                return;
            }

            // Calculate aspect ratio for cart thumbnail display (horizontal layout)
            // Height/Width percentage based on template count
            var aspectRatioMap = {
                2: 80,    // 40/50 * 100 = 80% (landscape)
                3: 67,    // 40/60 * 100 ≈ 67% (wider)
                4: 57     // 40/70 * 100 ≈ 57% (widest)
            };
            var aspectRatioPercent = aspectRatioMap[formData.template_count] || 80;

            // The orders/paid webhook (skylit-admin app/api/webhook/route.ts)
            // reads `_selected_size` / `_selected_type` / `_selected_frame` to
            // populate the D1 row's size/selected_type/selected_frame columns.
            // All other product customizers (star, moon, custom-print, location)
            // already send these keys; h-moon historically didn't, which left
            // those columns blank for paid h-moon orders. Map our local field
            // names to the canonical keys here.
            var selectedTypeUpper = (formData.product_option || '')
                .toUpperCase()
                .replace(/^PRINT ONLY$/, 'PRINT');
            if (selectedTypeUpper === 'BLACK' || selectedTypeUpper === 'WHITE' || selectedTypeUpper === 'NATURAL') {
                selectedTypeUpper = 'FRAMED';
            }

            // Copy reference tying this print to its own gift add-on. The
            // design's _OrderID is shared between copies, so the cart and
            // drawer controls pair on this instead.
            var lineRef = window.SkylitPairing
                ? window.SkylitPairing.makeLineRef()
                : formData.order_id;

            // Build line item properties for Shopify
            var properties = {
                'Product Type': formData.product_type,
                '_OrderID': formData.order_id,
                '_cart_line_ref': lineRef,
                // 'Size' is the customer-visible cart label ('40 x 30 cm');
                // '_selected_size' is the canonical machine token ('40x30')
                // the admin webhook stores and the renderers key on.
                'Size': formData.size,
                '_selected_size': String(formData.size || '').replace(/cm/gi, '').replace(/\s+/g, ''),
                '_selected_type': selectedTypeUpper,
                '_selected_frame': formData.frame_style,
                'Title': formData.title,
                'Subtitle': formData.subtitle,
                '_Background': formData.background,
                'Font': formData.font,
                '_composition': formData.composition,
                'Moon 1 Name': formData.moon1_name,
                'Moon 1 Date': formData.moon1_date,
                '_moon1_time': formData.moon1_time, // Hidden: used for moon phase calculation only
                'Moon 1 Location': formData.moon1_location,
                'Moon 2 Name': formData.moon2_name,
                'Moon 2 Date': formData.moon2_date,
                '_moon2_time': formData.moon2_time, // Hidden: used for moon phase calculation only
                'Moon 2 Location': formData.moon2_location,
                // Hidden properties for backend
                '_template_count': formData.template_count,
                '_size': formData.size, // Also store for backend rendering
                '_frame': formData.frame_style, // Store frame style for backend
                '_aspect_ratio': aspectRatioPercent,
                '_moon1_lat': formData.moon1_lat,
                '_moon1_lng': formData.moon1_lng,
                '_moon2_lat': formData.moon2_lat,
                '_moon2_lng': formData.moon2_lng,
                // "Moon Hue" — the per-moon colour picked in the customizer.
                // Hidden (the cart already shows the print itself), but written
                // to Shopify so the order carries its own record of the choice
                // independently of D1. Until 2026-09-04 the hue existed ONLY in
                // the customizer's DOM: /api/h-moon-map-data dropped it and no
                // cart property carried it, so when a customer disputed the
                // colours we had nothing to check (order vz2nv0r5ny7).
                '_moon_texture': formData.moon_texture,
                '_moon1_texture': formData.moon1_texture,
                '_moon2_texture': formData.moon2_texture,
                '_print_url': 'https://admin.skylitstudio.co.uk/api/download/' + formData.order_id,
                // NOTE: deliberately NOT setting '_thumbnail' — it used to point at
                // /api/download/ (the print endpoint, which 404s for an unpaid cart
                // item) and it WINS over '_thumbnail_final' in the cart-line Liquid
                // (`{% if _thumbnail %}...{% elsif _thumbnail_final %}`), so the cart
                // showed a broken/fallback image instead of the CF thumbnail. Moon
                // omits '_thumbnail' entirely for this reason; family now matches.
                // Cart line uses '_thumbnail_final' below (polls until it 200s).
                // Must be cart-thumbnail-img, NOT the print /download/ endpoint.
                '_thumbnail_final': 'https://admin.skylitstudio.co.uk/api/cart-thumbnail-img/' + formData.order_id,
                // The BARE print (no room, no frame). The cart composes the scene
                // live in CSS around this, so a frame bought from the cart's own
                // upsell appears instantly instead of needing a re-render. Falls
                // back to _thumbnail_final's baked composite when this 404s.
                '_thumbnail_print': 'https://admin.skylitstudio.co.uk/api/cart-print-img/' + formData.order_id
            };

            // Add Frame property only for framed products (visible in cart)
            if (formData.frame_style && formData.frame_style !== 'None') {
                properties['Frame'] = formData.frame_style;
            }

            // Add moon 3 properties if applicable
            if (formData.template_count >= 3 && formData.moon3_name) {
                properties['Moon 3 Name'] = formData.moon3_name;
                properties['Moon 3 Date'] = formData.moon3_date;
                properties['_moon3_time'] = formData.moon3_time; // Hidden: for moon phase calculation only
                properties['Moon 3 Location'] = formData.moon3_location;
                properties['_moon3_lat'] = formData.moon3_lat;
                properties['_moon3_lng'] = formData.moon3_lng;
                properties['_moon3_texture'] = formData.moon3_texture;
            }

            // Add moon 4 properties if applicable
            if (formData.template_count >= 4 && formData.moon4_name) {
                properties['Moon 4 Name'] = formData.moon4_name;
                properties['Moon 4 Date'] = formData.moon4_date;
                properties['_moon4_time'] = formData.moon4_time; // Hidden: for moon phase calculation only
                properties['Moon 4 Location'] = formData.moon4_location;
                properties['_moon4_lat'] = formData.moon4_lat;
                properties['_moon4_lng'] = formData.moon4_lng;
                properties['_moon4_texture'] = formData.moon4_texture;
            }
            if (window.SkylitGalleryWall) window.SkylitGalleryWall.applyProperties(properties);

            // Read gift-note state from the local-only snippet DOM.
            function readGiftDom() {
                var out = { note: '', design: 'editorial', font: 'handwritten', enabled: false };
                try {
                    var ta = document.getElementById('Gift-note-hormoon');
                    if (ta) out.note = ta.value || '';
                    var root = document.querySelector('.gnc[data-gnc="hormoon"]');
                    if (root) {
                        var d = root.getAttribute('data-design');
                        if (d === 'editorial' || d === 'minimal') out.design = d;
                        var f = root.getAttribute('data-font');
                        if (f === 'handwritten' || f === 'classic') out.font = f;
                        out.enabled = root.getAttribute('data-enabled') === 'true';
                    }
                } catch (_) {}
                return out;
            }
            // After the print is added, push a paired gift line carrying the
            // wrapping config — including gift note + design as line-item
            // properties when a ribbon/bundle is selected (no more cart-
            // attribute writes).
            // Wrap/bundle are size-tiered by the print; GIFT_IDS (smallest
            // tier) stays as the fallback when the shared map is missing.
            function hmGiftVariantId(kind) {
                try {
                    var tiered = window.SkylitGifts && window.SkylitGifts.variantFor(kind, formData.size, window.hmGiftPaper);
                    if (tiered) return String(tiered);
                } catch (e) {}
                return GIFT_IDS[kind];
            }
            function addPairedGift() {
                var giftOption = formData.gift_option || 'none';
                if (giftOption === 'none' || !GIFT_IDS[giftOption]) return Promise.resolve();
                var paperKey = window.SkylitGifts ? window.SkylitGifts.designKey(window.hmGiftPaper) : 'regular';
                var paperLabel = window.SkylitGifts ? window.SkylitGifts.labelFor(paperKey) : 'Regular';
                var giftProps = {
                    _paired_with_order_id: formData.order_id,
                    _paired_with_line_ref: lineRef
                };
                if (giftOption === 'ribbon' || giftOption === 'bundle') {
                    var hmRibbon = window.SkylitGifts ? window.SkylitGifts.ribbonColorKey(window.hmRibbonColor) : (window.hmRibbonColor || 'Red');
                    if (window.SkylitGifts) window.SkylitGifts.rememberRibbon('hm_' + formData.order_id, hmRibbon);
                    giftProps['Ribbon Colour'] = hmRibbon;
                    giftProps._ribbon_color = hmRibbon;
                }
                if (giftOption === 'giftwrap' || giftOption === 'bundle') {
                    giftProps['Gift Wrap Theme'] = paperLabel;
                    giftProps._gift_wrap_theme = paperKey;
                }
                var dom = readGiftDom();
                if ((giftOption === 'ribbon' || giftOption === 'bundle') &&
                    dom.enabled && dom.note.trim()) {
                    giftProps._gift_note = dom.note;
                    giftProps._gift_card_design = dom.design;
                    giftProps._gift_card_font = dom.font;
                }
                return postForm('/cart/add.js', { quantity: 1, id: hmGiftVariantId(giftOption), properties: giftProps })
                    .then(function() {}, function() {});
            }

            // Function to add the item to cart
            function doAddToCart() {
                postForm('/cart/add.js', {
                    quantity: 1,
                    id: variantId,
                    properties: properties
                }).then(function(response) {
                        addPairedGift().then(function() {
                            // Wait for the order save before resolving (the
                            // caller navigates to /cart on resolve, which
                            // aborts in-flight fetches). Capped at 8s so a
                            // hung save can never block checkout.
                            var save = sendToBackend(formData);
                            var cap = new Promise(function(r) { setTimeout(r, 8000); });
                            Promise.race([save, cap]).then(function() {
                                resolve(response);
                            });

                            // The cart thumbnail is rendered server-side, triggered
                            // inside the h-moon-map-data save above. It used to be a
                            // separate fire-and-forget POST from here, which raced the
                            // navigation to /cart and was sometimes dropped before it
                            // left the device even with keepalive — the save is awaited,
                            // so it cannot be lost.
                        });
                }, function(error) {
                    reject(error);
                });
            }

            // Drop anything this design already owns in the cart (print +
            // paired ribbon/wrap/bundle/wall strips) before adding. Driven by
            // a LIVE /cart.js read, not the page-load snapshot: a page restored
            // from the back-forward cache still thinks the cart is empty, and
            // skipping this is what produced duplicate paid gift lines.
            if (window.SkylitPairing) {
                window.SkylitPairing.purgeDesign(formData.order_id).then(doAddToCart, doAddToCart);
            } else if (isEditMode && cart_order_id_present.includes(formData.order_id)) {
                // Helper missing (asset blocked) — old snapshot path.
                window.__skylitCartEditInFlight = true;
                postForm('/cart/change.js', {
                    id: cart_order_id_present_id[cart_order_id_present.indexOf(formData.order_id)],
                    quantity: 0
                }).then(doAddToCart, doAddToCart);
            } else {
                doAddToCart();
            }
        });
    }

    // ============================================
    // SEND DATA TO BACKEND
    // ============================================
    // funnelStatus: 'cart' (add-to-cart, default) | 'draft' (autosave / save-for-later).
    // The route's no-regress guard prevents downgrades.
    function sendToBackend(formData, funnelStatus, cartEdit) {
        var backendData = {
            order: formData.order_id,
            funnel_status: funnelStatus || 'cart',
            product_type: formData.product_type,
            template_count: formData.template_count,
            title: formData.title,
            subtitle: formData.subtitle,
            background: formData.background,
            font: formData.font,
            details_font: formData.details_font,
            composition: formData.composition,
            // "Moon Hue". getFormData() has carried these since the picker
            // shipped (c652b0c), but this payload is a curated re-map rather
            // than formData itself, so they were never actually POSTed — the
            // save body had no texture key at any level. That, on top of the
            // missing D1 column, is why every family moon rendered silver.
            // Keep the nested `texture` keys in step with the flat ones: the
            // save route reads `data.moonN_texture ?? mN.texture`.
            moon_texture: formData.moon_texture,
            moon1: {
                name: formData.moon1_name,
                date: formData.moon1_date,
                time: formData.moon1_time,
                location: formData.moon1_location,
                lat: formData.moon1_lat,
                lng: formData.moon1_lng,
                phase: formData.moon1_phase,
                illumination: formData.moon1_illumination,
                iso_timestamp: formData.moon1_iso_timestamp,
                texture: formData.moon1_texture,
                canvas_data: formData.moon1_canvas_data
            },
            moon2: {
                name: formData.moon2_name,
                date: formData.moon2_date,
                time: formData.moon2_time,
                location: formData.moon2_location,
                lat: formData.moon2_lat,
                lng: formData.moon2_lng,
                phase: formData.moon2_phase,
                illumination: formData.moon2_illumination,
                iso_timestamp: formData.moon2_iso_timestamp,
                texture: formData.moon2_texture,
                canvas_data: formData.moon2_canvas_data
            },
            moon3: {
                name: formData.moon3_name,
                date: formData.moon3_date,
                time: formData.moon3_time,
                location: formData.moon3_location,
                lat: formData.moon3_lat,
                lng: formData.moon3_lng,
                phase: formData.moon3_phase,
                illumination: formData.moon3_illumination,
                iso_timestamp: formData.moon3_iso_timestamp,
                texture: formData.moon3_texture,
                canvas_data: formData.moon3_canvas_data
            },
            moon4: {
                name: formData.moon4_name,
                date: formData.moon4_date,
                time: formData.moon4_time,
                location: formData.moon4_location,
                lat: formData.moon4_lat,
                lng: formData.moon4_lng,
                phase: formData.moon4_phase,
                illumination: formData.moon4_illumination,
                iso_timestamp: formData.moon4_iso_timestamp,
                texture: formData.moon4_texture,
                canvas_data: formData.moon4_canvas_data
            },
            size: formData.size,
            frame: formData.frame_style,
            product_option: formData.product_option,
            gift_option: formData.gift_option || 'none',
            // Authoring-device snapshot for admin-side ad/reporting segmentation.
            // Server parses userAgentData (Client Hints) first, falls back to UA regex.
            device: (function(){
                var uad = null;
                try {
                    if (navigator.userAgentData) {
                        uad = {
                            brands: navigator.userAgentData.brands || null,
                            mobile: !!navigator.userAgentData.mobile,
                            platform: navigator.userAgentData.platform || ''
                        };
                    }
                } catch (e) {}
                return {
                    userAgent: (navigator && navigator.userAgent) || '',
                    userAgentData: uad,
                    viewport: { w: window.innerWidth, h: window.innerHeight }
                };
            })()
        };

        // (A second fire-and-forget POST to CONFIG.adminEndpoint used to sit
        // here — adminEndpoint === apiEndpoint, so every save hit the backend
        // twice with the identical multi-MB canvas payload. Removed.)
        // Returned so callers can hold off navigation until the save lands.
        // Navigating to /cart aborts in-flight fetches; on slow connections
        // the order save was getting killed and the customer's edits lost.
        // Never rejects — the .catch keeps it non-blocking.
        // Cart edit log (scheduleHmCartEditLog): note it and stop.
        if (cartEdit) {
            fetch(CONFIG.apiEndpoint + '/api/cart-edit', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ product_type: 'hor_moon', data: backendData }, function(k, v) { return (typeof v === 'string' && v.length > 1000 && v.indexOf('data:') === 0) ? undefined : v; })
            }).catch(function() {});
            return Promise.resolve(false);
        }
        return fetch(CONFIG.apiEndpoint + '/api/h-moon-map-data/', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(backendData)
        })
        .then(function(response) {
            var ok = response.ok;
            return response.json()
                .catch(function() { return null; })
                .then(function(data) {
                    console.log('Backend response:', data);
                    if (ok && data && data.cart_thumbnail_token) {
                        hmCartThumbnailToken = data.cart_thumbnail_token;
                    }
                    // Resolve true only when the save actually landed, so
                    // callers (autosave pointer write) can gate on success.
                    return ok;
                });
        })
        .catch(function(error) {
            console.warn('Backend save failed (non-blocking):', error);
            return false;
        });
    }

    // ============================================
    // LOAD H-MOON MAP DATA (for editing existing orders)
    // ============================================
    function loadHMoonMapData(orderId) {
        if (!orderId) return;

        console.log('🌙 Loading H-Moon order:', orderId);
        fadeIn('.myloader', 400);

        fetch(CONFIG.apiEndpoint + '/api/h-moon-map-data/?order_no=' + orderId, {
            method: 'GET'
        })
        .then(function(response) {
            if (!response.ok) {
                throw new Error('Failed to fetch order: ' + response.status);
            }
            return response.json();
        })
        .then(function(content) {
            console.log('🌙 Loaded H-Moon data:', content);

            // Set the order_id from the content if available
            if (content.order) {
                order_id = content.order;
                // This is the real backend order id (as opposed to the
                // random one order_id started as at page load). Re-key the
                // remembered paper choice to it so a returning customer's
                // festive paper choice restores alongside their design.
                window.hmGiftPaper = (window.SkylitGifts && window.SkylitGifts.recallPaperFor('hm_' + order_id)) || window.hmGiftPaper;
                if (window.hmGiftPaperPicker && typeof window.hmGiftPaperPicker.set === 'function') {
                    window.hmGiftPaperPicker.set(window.hmGiftPaper);
                }
                window.hmRibbonColor = (window.SkylitGifts && window.SkylitGifts.recallRibbonFor('hm_' + order_id)) || window.hmRibbonColor || 'Red';
                if (window.hmRibbonPicker && typeof window.hmRibbonPicker.set === 'function') window.hmRibbonPicker.set(window.hmRibbonColor);
                if (typeof window.renderHOverlays === 'function') window.renderHOverlays();
            }

            // Apply customizations
            applyHMoonMapCustomizations(content);
            fadeOut('.myloader', 400);
        })
        .catch(function(error) {
            console.error('❌ Error loading H-Moon data:', error);
            fadeOut('.myloader', 400);
        });
    }

    // ============================================
    // APPLY H-MOON MAP CUSTOMIZATIONS FROM SAVED DATA
    // ============================================
    function applyHMoonMapCustomizations(content) {
        if (!content) return;

        console.log('🎨 Applying H-Moon customizations...');

        // Helper function to safely click an element
        function safeClick(els, description) {
            if (els && els.length > 0) {
                try {
                    els.forEach(function (el) { el.click(); });
                    console.log('✅ Clicked:', description);
                    return true;
                } catch (e) {
                    console.warn('⚠️ Error clicking ' + description + ':', e);
                    return false;
                }
            }
            console.warn('⚠️ Element not found:', description);
            return false;
        }

        // Helper to parse date string "DD/MM/YYYY" or "1st May, 2020" format
        function parseDateString(dateStr) {
            if (!dateStr) return null;

            // "25th January, 2020 - 2:00 PM": the moon's "Show time on print"
            // tick appends its time to the date. Parse the date part and
            // report the time, so the pickers land on the saved day and the
            // tick comes back on (it is not stored anywhere else). Unparsed,
            // the pickers kept their defaults and changing the time rebuilt
            // the date from them, jumping the moon to 14 Mar 2023.
            var timed = String(dateStr).match(/^(.*\S)\s+[-\u2013]\s+\d{1,2}:\d{2}(?:\s*[AP]\.?M\.?)?\s*$/i);
            if (timed) {
                var dated = parseDateString(timed[1]);
                if (dated) dated.hasTime = true;
                return dated;
            }

            var monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
                              'July', 'August', 'September', 'October', 'November', 'December'];

            // DD/MM/YYYY → 'numeric'
            var slashParts = dateStr.split('/');
            if (slashParts.length === 3) {
                return {
                    day: parseInt(slashParts[0]),
                    month: parseInt(slashParts[1]) - 1, // 0-indexed
                    year: parseInt(slashParts[2]),
                    format: 'numeric'
                };
            }

            // "1st May, 2020" → 'written' / "1 May 2020" → 'plain'
            var match = dateStr.match(/^(\d+)(st|nd|rd|th)?\s+(\w+),?\s+(\d{4})$/);
            if (match) {
                var monthIndex = monthNames.indexOf(match[3]);
                if (monthIndex !== -1) {
                    return {
                        day: parseInt(match[1]),
                        month: monthIndex,
                        year: parseInt(match[4]),
                        format: match[2] ? 'written' : 'plain'
                    };
                }
            }

            // "May 1st, 2020" → 'us'
            var usMatch = dateStr.match(/^(\w+)\s+(\d+)(?:st|nd|rd|th)?,?\s+(\d{4})$/);
            if (usMatch) {
                var usMonth = monthNames.indexOf(usMatch[1]);
                if (usMonth !== -1) {
                    return {
                        day: parseInt(usMatch[2]),
                        month: usMonth,
                        year: parseInt(usMatch[3]),
                        format: 'us'
                    };
                }
            }

            return null;
        }

        // Helper to parse time string "HH:MM"
        function parseTimeString(timeStr) {
            if (!timeStr) return null;
            var parts = timeStr.split(':');
            if (parts.length >= 2) {
                return {
                    hours: parseInt(parts[0]),
                    minutes: parseInt(parts[1])
                };
            }
            return null;
        }

        // Determine template count - check explicit value or infer from moon data
        // Backend may return as template_type or template_count
        var templateCount = content.template_count || content.template_type;
        if (!templateCount) {
            // Infer from which moons have data (flat properties: moon3_name, moon4_name)
            if (content.moon4_name) {
                templateCount = 4;
            } else if (content.moon3_name) {
                templateCount = 3;
            } else {
                templateCount = 2;
            }
        }
        templateCount = parseInt(templateCount) || 2;

        console.log('🌙 Template count to apply:', templateCount);

        // Template count (2/3/4 moons) first - the other customizations
        // need its moon slots. Then the composition; Portrait 2x2 only
        // exists with 4 moons.
        if (templateCount >= 2 && templateCount <= 4) {
            window.HMoonCore.setTemplate(templateCount, { flip: false, silent: true });
        }
        var savedComp = (content.composition || '').trim() || 'classic';
        if (savedComp === 'quad-portrait' && templateCount !== 4) savedComp = 'classic';
        if (q('.h-tile--comp[data-composition="' + savedComp + '"]')) {
            window.HMoonCore.setComposition(savedComp, { flip: false, silent: true });
        }

        // Restore product type / size / frame colour (variant option1/2/3).
        // Without this the selection keeps its boot default (Framed A4), so
        // reopening a saved order to edit silently changed the size.
        (function restoreHMoonVariant() {
            var savedType = (content.product_option || content.selected_type || '').trim();
            var savedSize = (content.size || '').trim();
            var savedFrame = (content.frame_style || content.frame || '').trim();
            if (!savedType && !savedSize && !savedFrame) return;
            window.HMoonCore.restoreSelection(savedType, savedSize, savedFrame);
            console.log('🖼️ H-Moon variant restored:', savedType, '/', savedSize, '/', savedFrame || '—');
        })();

        // Restore the wrapping. Editing from the cart purges the print and its
        // gift line and re-adds both from this selection, so a design that
        // came back without its gift used to lose the wrap on Confirm Edits.
        if (content.gift_option && { ribbon: 1, giftwrap: 1, bundle: 1, none: 1 }[content.gift_option]) {
            window.HMoonCore.setGift(content.gift_option);
        }

        // Longer delay to allow template UI and moon renderers to initialize
        setTimeout(function() {
            // Apply title and subtitle. Use `!= null` rather than truthy
            // checks so deliberately-cleared values round-trip as empty.
            // Otherwise the customizer keeps its initial default and a re-save
            // would overwrite the customer's empty choice.
            if (content.title != null) {
                setVal('#h-textTitle', content.title); fire(q('#h-textTitle'), 'input');
            }
            if (content.subtitle != null) {
                setVal('#h-textSubtitle', content.subtitle); fire(q('#h-textSubtitle'), 'input');
            }

            // Apply background
            if (content.background && q('.h-background-option[data-bg="' + content.background + '"]')) {
                window.HMoonCore.setBackground(content.background, { silent: true });
            }

            // Fonts: `font` is the message font, `details_font` the per-moon
            // labels (older saves have only `font`, used for both).
            if (content.font || content.details_font) {
                window.HMoonCore.setFonts(content.font, content.details_font);
            }

            // Restore per-moon textures
            for (var texMoonId = 1; texMoonId <= templateCount; texMoonId++) {
                var texVariant = content['moon' + texMoonId + '_texture'] || content.moon_texture || 'silver';
                if (texVariant !== 'silver') {
                    window.HMoonCore.setTexture(texMoonId, texVariant, { silent: true });
                }
            }

            // Apply moon data for each moon (1-4)
            // Backend returns flat properties: moon1_name, moon1_date, etc. (not nested)
            var hydratedDateFormat = null;
            var verbatimDates = {};
            for (var moonId = 1; moonId <= templateCount; moonId++) {
                var prefix = 'moon' + moonId + '_';

                // Get moon data from flat properties
                var moonName = content[prefix + 'name'];
                var moonDate = content[prefix + 'date'];
                var moonTime = content[prefix + 'time'];
                var moonLocation = content[prefix + 'location'];
                var moonLat = content[prefix + 'lat'];
                var moonLng = content[prefix + 'lng'];

                console.log('🌙 Applying Moon ' + moonId + ' data:', {
                    name: moonName,
                    date: moonDate,
                    time: moonTime,
                    location: moonLocation
                });

                // Apply moon name/label. `!= null`: a label the customer
                // cleared is saved as "" and must reopen blank, not as the
                // input's default ("We Met", "Moon 3"), which a re-save stored.
                if (moonName != null) {
                    setVal('#h-moon' + moonId + 'Name', moonName); fire(q('#h-moon' + moonId + 'Name'), 'input');
                }

                // Apply location
                if (moonLocation) {
                    setVal('#h-address_form1_moon' + moonId, moonLocation);
                    setVal('#h-custom_address_moon' + moonId, moonLocation);
                    setVal('#h-custom_location_moon' + moonId, moonLocation);
                    setText('#h-moon-location-' + moonId, moonLocation);

                    // Mark that user has entered a location
                    if (moonLocation && moonLocation.length > 0) {
                        window.hUserEnteredLocations['moon' + moonId] = true;
                    }

                    // Show it in the search box too. The box may not exist
                    // yet (Google Maps loads lazily on first touch); when it
                    // doesn't, setupAutocomplete syncs from the mirror at bind
                    // time instead. Between the two, the resumed draft reads
                    // correctly whichever order the race resolves in.
                    if (typeof window.hMoonSyncLocationInput === 'function') {
                        window.hMoonSyncLocationInput(moonId);
                    }

                    // Update the generator location if available
                    if (moonLat && moonLng && window.hMoonInstances && window.hMoonInstances[moonId]) {
                        window.hMoonInstances[moonId].currentLocation = {
                            lat: parseFloat(moonLat),
                            lng: parseFloat(moonLng),
                            name: moonLocation
                        };
                    }
                }

                // Apply date
                var dateInfo = parseDateString(moonDate);
                if (dateInfo) {
                    setVal('.h-bear-dates[data-moon="' + moonId + '"]', dateInfo.day);
                    setVal('.h-bear-months[data-moon="' + moonId + '"]', dateInfo.month);
                    setVal('.h-bear-years[data-moon="' + moonId + '"]', dateInfo.year);

                    // Mark date as selected
                    window.hUserSelectedDates['moon' + moonId] = true;

                    var timeCb = document.getElementById('h-moon-time-on-' + moonId);
                    if (timeCb) timeCb.checked = !!dateInfo.hasTime;

                    // Restore the global date-format toggle from the first
                    // parseable saved date, so the year-change trigger below
                    // regenerates labels in the order's own format.
                    if (!hydratedDateFormat && dateInfo.format) hydratedDateFormat = dateInfo.format;
                } else if (moonDate) {
                    // Custom text matching no known format — keep it verbatim;
                    // the trigger pass below must not reformat it away.
                    verbatimDates[moonId] = moonDate;
                }

                // Apply time
                var timeInfo = parseTimeString(moonTime);
                if (timeInfo) {
                    setVal('.h-moon-hours[data-moon="' + moonId + '"]', timeInfo.hours);
                    setVal('.h-moon-minutes[data-moon="' + moonId + '"]', timeInfo.minutes);
                }

                // Update the date display text
                if (moonDate) {
                    setText('#h-moon-date-' + moonId, moonDate);
                    setVal('#h-custom_date_moon' + moonId, moonDate);
                    // Restore the per-moon "Show time on print" checkbox: the saved
                    // printed date carries the time (" - 9:00 PM") when it was on.
                    if (/ - \d{1,2}:\d{2}/.test(moonDate)) {
                        qa('#h-moon-time-on-' + moonId).forEach(function (cb) { cb.checked = true; });
                    }
                }
            }

            // Apply the order's date format BEFORE the year-change triggers
            // below — they regenerate every date label via the generator's
            // formatter, which reads window.hMoonDateFormat.
            if (hydratedDateFormat && typeof window.hMoonSetDateFormat === 'function') {
                window.hMoonSetDateFormat(hydratedDateFormat, true);
            }

            // Trigger moon updates after a delay to ensure all values are set and renderers are ready
            setTimeout(function() {
                for (var i = 1; i <= templateCount; i++) {
                    // Trigger change on year selector to recalculate moon phases
                    qa('.h-bear-years[data-moon="' + i + '"]').forEach(function (sel) { fire(sel, 'change'); });
                }

                // Re-apply custom date text the trigger pass reformatted away
                for (var vd in verbatimDates) {
                    setText('#h-moon-date-' + vd, verbatimDates[vd]);
                    setVal('#h-custom_date_moon' + vd, verbatimDates[vd]);
                }

                // Override each moon's currentDate with the original UTC instant from
                // iso_timestamp. The dropdown-triggered updateDateFromSelectors rebuilds
                // currentDate in the reloading browser's timezone, which drifts from
                // the renderer's rotation whenever the customer's tz differs from ours.
                if (typeof window.setHMoonDate === 'function') {
                    for (var j = 1; j <= templateCount; j++) {
                        var iso = content['moon' + j + '_iso_timestamp'];
                        if (iso) {
                            var d = new Date(iso);
                            if (!isNaN(d.getTime())) {
                                window.setHMoonDate(j, d);
                            }
                        }
                    }
                }

                // Update button text based on loaded locations
                if (typeof window.updateHAddToCartButtonText === 'function') {
                    window.updateHAddToCartButtonText();
                }

                console.log('🌙 H-Moon customizations applied successfully');
            }, 500);

        }, 600); // Longer delay to allow template switch to initialize moon 3/4 renderers
    }

    // Expose loadHMoonMapData globally
    window.loadHMoonMapData = loadHMoonMapData;

    // ============================================
    // COOKIE MANAGEMENT FOR DATA PERSISTENCE
    // ============================================
    function saveDataToCookie(data) {
        try {
            var cookieValue = JSON.stringify(data);
            setCookie(CONFIG.cookieName, cookieValue, CONFIG.cookieExpiry);
            console.log('Data saved to cookie');
        } catch (e) {
            console.warn('Failed to save to cookie:', e);
        }
    }

    function loadSavedData() {
        try {
            var cookieValue = getCookie(CONFIG.cookieName);
            if (cookieValue) {
                var data = JSON.parse(cookieValue);
                console.log('Loaded saved data:', data);
                restoreFormData(data);
                return data;
            }
        } catch (e) {
            console.warn('Failed to load from cookie:', e);
        }
        return null;
    }

    function restoreFormData(data) {
        if (!data) return;

        // Restore text fields with delay to ensure DOM is ready
        setTimeout(function() {
            if (data.title) {
                setVal('#h-textTitle', data.title); fire(q('#h-textTitle'), 'input');
            }
            if (data.subtitle) {
                setVal('#h-textSubtitle', data.subtitle); fire(q('#h-textSubtitle'), 'input');
            }
            if (data.moon1_name) {
                setVal('#h-moon1Name', data.moon1_name); fire(q('#h-moon1Name'), 'input');
            }
            if (data.moon2_name) {
                setVal('#h-moon2Name', data.moon2_name); fire(q('#h-moon2Name'), 'input');
            }
            if (data.moon3_name) {
                setVal('#h-moon3Name', data.moon3_name); fire(q('#h-moon3Name'), 'input');
            }
            if (data.moon4_name) {
                setVal('#h-moon4Name', data.moon4_name); fire(q('#h-moon4Name'), 'input');
            }

            // Restore location fields
            if (data.moon1_location) {
                setVal('#h-address_form1_moon1', data.moon1_location);
                setVal('#h-custom_address_moon1', data.moon1_location);
                setText('#h-moon-location-1', data.moon1_location.toUpperCase());
                window.hUserEnteredLocations.moon1 = true;
            }
            if (data.moon2_location) {
                setVal('#h-address_form1_moon2', data.moon2_location);
                setVal('#h-custom_address_moon2', data.moon2_location);
                setText('#h-moon-location-2', data.moon2_location.toUpperCase());
                window.hUserEnteredLocations.moon2 = true;
            }
            if (data.moon3_location) {
                setVal('#h-address_form1_moon3', data.moon3_location);
                setVal('#h-custom_address_moon3', data.moon3_location);
                setText('#h-moon-location-3', data.moon3_location.toUpperCase());
                window.hUserEnteredLocations.moon3 = true;
            }
            if (data.moon4_location) {
                setVal('#h-address_form1_moon4', data.moon4_location);
                setVal('#h-custom_address_moon4', data.moon4_location);
                setText('#h-moon-location-4', data.moon4_location.toUpperCase());
                window.hUserEnteredLocations.moon4 = true;
            }

            // Dates are deliberately NOT flagged as selected here: nothing
            // restores the saved date into the pickers (they stay on the
            // page-load default), so flagging them let a returning customer
            // pass validation with a date they never set.

            // Restore gift selection so a returning customer's previously
            // chosen ribbon/wrap/bundle re-appears in the picker.
            if (data.gift_option) {
                var slugMap = { none: 1, ribbon: 1, giftwrap: 1, bundle: 1 };
                window.HMoonCore.setGift(slugMap[data.gift_option] ? data.gift_option : 'none');

                // Re-key the remembered paper choice to the order id carried in
                // this saved payload. It may be the real backend order id from
                // a previous loadHMoonMapData() resume that got written back
                // into the cookie, not just this tab's throwaway order_id.
                var hmResumeOrderId = data.order_id || order_id;
                window.hmGiftPaper = (window.SkylitGifts && window.SkylitGifts.recallPaperFor('hm_' + hmResumeOrderId)) || window.hmGiftPaper;
                if (window.hmGiftPaperPicker && typeof window.hmGiftPaperPicker.set === 'function') {
                    window.hmGiftPaperPicker.set(window.hmGiftPaper);
                }
                window.hmRibbonColor = (window.SkylitGifts && window.SkylitGifts.recallRibbonFor('hm_' + hmResumeOrderId)) || window.hmRibbonColor || 'Red';
                if (window.hmRibbonPicker && typeof window.hmRibbonPicker.set === 'function') window.hmRibbonPicker.set(window.hmRibbonColor);
                if (typeof window.renderHOverlays === 'function') window.renderHOverlays();
            }

            // Update button text based on loaded locations and dates
            if (typeof window.updateHAddToCartButtonText === 'function') {
                window.updateHAddToCartButtonText();
            }

            console.log('Form data restored from cookie');
        }, 500);
    }

    // ============================================
    // NOTIFICATIONS
    // ============================================
    function showNotification(message, background, ms) {
        var notification = document.createElement('div');
        notification.className = 'h-success-notification';
        if (background) notification.style.background = background;
        notification.innerHTML = message;
        document.body.appendChild(notification);
        setTimeout(function() {
            fadeOut(notification, 300, function() {
                if (this.parentNode) this.parentNode.removeChild(this);
            });
        }, ms);
    }

    function showSuccessNotification(message) {
        showNotification(message, null, 2000);
    }

    function showErrorNotification(message) {
        showNotification(message, '#e74c3c', 3000);
    }

    // ============================================
    // TOOLTIP POSITIONING + TAP-TO-TOGGLE
    // .h-tooltip-content is position:fixed; anchor it under its icon and
    // clamp to the viewport so it never clips against the sidebar tiles
    // (which have overflow:hidden) or the window edges.
    // The ribbon icon holds TWO content spans (--print / --wrapped, one
    // display:none per the selected finish) — position every visible one,
    // not just querySelector's first match, or the shown span renders
    // unpositioned half off-screen.
    // Tapping the icon toggles .h-tooltip-open because WebKit's simulated
    // :hover collapses the moment the tile's click handler mutates the DOM
    // (the tooltip flashed for a frame then vanished on phones).
    // ============================================
    function positionHTooltip(icon) {
        var tips = icon.querySelectorAll('.h-tooltip-content');
        var r = icon.getBoundingClientRect();
        for (var i = 0; i < tips.length; i++) {
            var tip = tips[i];
            if (window.getComputedStyle(tip).display === 'none') continue;
            var w = tip.offsetWidth || 220;
            var h = tip.offsetHeight || 80;
            var left = Math.max(8, Math.min(r.left + r.width / 2 - w / 2,
                                            window.innerWidth - w - 8));
            var top = r.bottom + 8;
            if (top + h > window.innerHeight - 8) top = r.top - h - 8;
            tip.style.left = left + 'px';
            tip.style.top = top + 'px';
        }
    }
    // jQuery's delegated mouseenter: mouseover where the pointer arrived
    // from outside the icon.
    document.addEventListener('mouseover', function(e) {
        var icon = e.target && e.target.closest ? e.target.closest('.h-tooltip-icon') : null;
        if (!icon) return;
        if (e.relatedTarget && icon.contains(e.relatedTarget)) return;
        positionHTooltip(icon);
    });
    // Capture phase so stopPropagation runs BEFORE the delegated
    // .h-gift_picker / .h-elem__picker click handlers — a tap on the "?"
    // must open the tooltip, not also select/deselect the tile.
    document.addEventListener('click', function(e) {
        var icon = e.target.closest ? e.target.closest('.h-tooltip-icon') : null;
        if (!icon) {
            qa('.h-tooltip-open').forEach(function (el) { el.classList.remove('h-tooltip-open'); });
            return;
        }
        e.stopPropagation();
        var wasOpen = icon.classList.contains('h-tooltip-open');
        qa('.h-tooltip-open').forEach(function (el) { el.classList.remove('h-tooltip-open'); });
        if (!wasOpen) {
            positionHTooltip(icon);
            icon.classList.add('h-tooltip-open');
        }
    }, true);

    // ============================================
    // EXPORT FOR DEBUGGING
    // ============================================
    window.hMoonFormHandler = {
        collect: collectFormData,
        save: saveDataToCookie,
        load: loadSavedData,
        getOrderId: function() { return order_id; }
    };

})();

// ── Shared motion (skylit-motion.js) ─────────────────────────────────────────
// Sliding step-tab pill, as on the star map and single moon. Back from the
// cart restores this page as it left it, mid-"Added": put the button back.
(function () {
    function attachPill() {
        if (window.SkylitTabPill) {
            document.querySelectorAll(".cust-step-nav").forEach(function (nav) {
                window.SkylitTabPill.attach(nav, { tab: ".cust-step-tab", className: "cust-steps-indicator" });
            });
        }
    }
    // Same timing as the jQuery ready it replaces (one task after DOMContentLoaded).
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(attachPill, 0); });
    else setTimeout(attachPill, 0);
})();
window.addEventListener("pageshow", function (e) {
    if (e.persisted && window.SkylitAtcMorph) window.SkylitAtcMorph.reset(true);
    var btn = document.querySelector(".h-submit__form");
    if (e.persisted && btn) btn.style.pointerEvents = "";
});
